<div class="table-responsive">
  <div class="card">
    <div class="card-body">
      @if (!showProjectsView) {
        <div>
          <div class="row">
            <div class="col-md-12">
              <div class="button-items mb-1" style="float: left;padding-left: 1%;">
                <h2>Tasks</h2>
              </div>
              <div class="button-items" style="float: right;display: flex;" >
                <div class="search-container m-0">
                  <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="searchTerm" (keyup.enter)="loadTasksData(lastTableLazyLoadEvent)">
                  <button class="search-button" style="padding-bottom: 3px;" (click)="loadTasksData(lastTableLazyLoadEvent)" pTooltip="Search" appActionTooltip>
                    <img src="assets/images/search.png" alt="Search">
                  </button>
                  <button class="search-button sb-close btn-lg" (click)="searchTerm='';loadTasksData(lastTableLazyLoadEvent)" pTooltip="Clear search" appActionTooltip><i
                  class="mdi mdi-window-close"></i></button>
                </div>
                <button class="btn btn-primary btn-sm m-1"   (click)="loadTasksData(lastTableLazyLoadEvent)" pTooltip="Refresh Table" appActionTooltip><i
                class="mdi mdi-reload"></i></button>
                @if (!widgetFilters || widgetFilters?.length==0) {
                  <button class="btn btn-primary btn-sm m-1"  (click)="clearAllFilters(dt)" pTooltip="Clear Filters" appActionTooltip>Clear<i
                  class="mdi mdi-filter-remove"></i></button>
                }
                @if (widgetFilters && widgetFilters.length>0 && filterSource === 'widget') {
                  <button class="btn btn-danger btn-sm m-1" (click)="clearWidgetsFilter()" pTooltip="Clear Widgets Filters" appActionTooltip>Clear Widgets Filters<i
                  class="mdi mdi-filter-remove"></i></button>
                }
                @if (widgetFilters && widgetFilters.length>0 && filterSource === 'entity') {
                  <button class="btn btn-danger btn-sm m-1" (click)="clearWidgetsFilter()" pTooltip="Clear Entity Filters" appActionTooltip>Clear Entity Filters<i
                  class="mdi mdi-filter-remove"></i></button>
                }
                @if ((auth.roles?.includes('ADMIN') || auth.roles?.includes('Reporting')) && !tkdashboard) {
                  <span appActionTooltip [pTooltip]="btnLoading ? getExportDisabledReason() : 'Export to Excel'" [actionDisabled]="btnLoading">
                    <button class="btn btn-success btn-sm m-1" (click)="exportTasks()" [disabled]="btnLoading">
                      @if (!btnLoading) {
                        <span>
                          <i class="mdi mdi-file-excel"></i> Export
                        </span>
                      }
                      @if (btnLoading) {
                        <span>
                          <i class="mdi mdi-loading mdi-spin"></i> Exporting...
                        </span>
                      }
                    </button>
                  </span>
                }
              </div>
              <div style="float: right;margin-right: 2%;margin-top: -0.5%">
                @if (combroles && !dashboard) {
                  <p-tabView styleClass="toolbar-tabs" (onChange)="handleTabChange(dt,$event)">
                    <p-tabPanel header="LPC/ADMIN">
                    </p-tabPanel>
                    <p-tabPanel header="TK">
                    </p-tabPanel>
                  </p-tabView>
                }
              </div>
              @if (!dashboard) {
                <select style="height: 40px" class="form-status-select" [(ngModel)]="selectedFilterOption"
                  (change)='onTaskScopeChange(dt)' title="My Tasks">
                  @for (filter of filterOptions; track filter) {
                    <option
                    [ngValue]="filter.value" >{{filter.label}}</option>
                  }
                </select>
              }
              <div style="float:right">
                <button
                  [style.visibility]="activeTab === 'user' ? 'visible' : 'hidden'"
                  class="btn btn-link p-0 mr-2"
                  (click)="viewGridSettings()"
                  pTooltip="Customize Grid" appActionTooltip style="cursor: pointer;">
                  <i class="mdi mdi-cog fs-5 text-primary"></i>
                </button>
              </div>
              <div style="float: right;margin-right: 1%;margin-top: -0.5%">
                <p-tabView styleClass="toolbar-tabs" [activeIndex]="activeTab==='user' ? 1 : 0" (onChange)="handleTableTabChange($event)">
                  <p-tabPanel header="Default">
                  </p-tabPanel>
                  <p-tabPanel header="Custom">
                  </p-tabPanel>
                </p-tabView>
              </div>
            </div>
          </div>
          <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadTasksData($event)" [value]="tasks"
            dataKey="id" styleClass="p-datatable-tasks" [rowHover]="true" [rows]="10"
            [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
            responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0"
            paginatorDropdownAppendTo="body">
            <!-- ================= HEADER ================= -->
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width:1%; white-space:nowrap; text-align:center;">Actions</th>
                <!-- STATIC COLUMNS -->
                <th pSortableColumn="projectName">
                  <div class="flex justify-content-between align-items-center">
                    Project Name
                    <p-sortIcon field="projectName"></p-sortIcon>
                    <p-columnFilter type="text" field="projectName" matchMode="contains" display="menu"
                      [showOperator]="false" [showAddButton]="false">
                    </p-columnFilter>
                  </div>
                </th>
                <th pSortableColumn="taskName">
                  <div class="flex justify-content-between align-items-center">
                    Task Name
                    <p-sortIcon field="taskName"></p-sortIcon>
                    <p-columnFilter type="text" field="taskName" matchMode="contains" display="menu"
                      [showOperator]="false" [showAddButton]="false">
                    </p-columnFilter>
                  </div>
                </th>
                <th pSortableColumn="id">
                  <div class="flex justify-content-between align-items-center">
                    Task ID
                    <p-sortIcon field="id"></p-sortIcon>
                    <p-columnFilter matchMode="equals" [showOperator]="false" [showAddButton]="false" [showMatchModes]="true"
                    [matchModeOptions]="matchModeOptionsNumber" type="numeric" [useGrouping]="false" field="id" display="menu"></p-columnFilter>
                  </div>
                </th>
                <!-- DYNAMIC COLUMNS -->
                @for (col of cols; track col) {
                  @if (col.visible) {
                    <th [pSortableColumn]="col.field">
                      <div class="flex justify-content-between align-items-center">
                        {{ col.header }}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                        <!-- FILTER SECTION -->
                        @switch (col.field) {
                          <!-- ================= CUSTOM COLUMN FILTERS ================= -->
                          <!-- STATE -->
                          @case ('stateCode') {
                            <p-columnFilter
                              field="stateCode"
                              matchMode="equals"
                              display="menu"
                              [showMatchModes]="true"
                              [showOperator]="false"
                              [showAddButton]="false">
                              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown
                                  [ngModel]="value"
                                  [options]="stateCodeMapList"
                                  (onChange)="filter($event.value)"
                                  placeholder="Any">
                                  <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">
                                      {{ option.label }}
                                    </span>
                                  </ng-template>
                                </p-dropdown>
                              </ng-template>
                            </p-columnFilter>
                          }
                          <!-- TASK STATUS -->
                          @case ('statusCode') {
                            <p-columnFilter
                              field="statusCode"
                              display="menu"
                              [showMatchModes]="false"
                              [showOperator]="false"
                              [showAddButton]="false"
                              [showClearButton]="true"
                              [showApplyButton]="true">
                              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [maxSelectedLabels]="10000"
                                  [ngModel]="value"
                                  [options]="statuses"
                                  (onChange)="filter($event.value)"
                                  optionLabel="label"
                                  placeholder="Any">
                                  <ng-template let-option pTemplate="item">
                                    <div class="p-multiselect-representative-option">
                                      <span [class]="'customer-badge status-' + option.value">
                                        {{ option.label }}
                                      </span>
                                    </div>
                                  </ng-template>
                                </p-multiSelect>
                              </ng-template>
                            </p-columnFilter>
                          }
                          <!-- ASSIGNMENT STATUS -->
                          @case ('projTaskAssignmentStatus') {
                            <p-columnFilter
                              field="projTaskAssignmentStatus"
                              display="menu"
                              [showMatchModes]="false"
                              [showOperator]="false"
                              [showAddButton]="false">
                              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [maxSelectedLabels]="10000"
                                  [ngModel]="value"
                                  [options]="assignmentStatuses"
                                  (onChange)="filter($event.value)"
                                  optionLabel="label"
                                  placeholder="Any">
                                  <ng-template let-option pTemplate="item">
                                    <div class="p-multiselect-representative-option">
                                      <span [class]="'customer-badge status-' + option.value">
                                        {{ option.label }}
                                      </span>
                                    </div>
                                  </ng-template>
                                </p-multiSelect>
                              </ng-template>
                            </p-columnFilter>
                          }
                          <!-- REVIEW STATUS -->
                          @case ('reviewStatus') {
                            <p-columnFilter
                              field="reviewStatus"
                              display="menu"
                              [showMatchModes]="false"
                              [showOperator]="false"
                              [showAddButton]="false">
                              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [maxSelectedLabels]="10000"
                                  [ngModel]="value"
                                  [options]="reviewstatuslist"
                                  (onChange)="filter($event.value)"
                                  optionLabel="label"
                                  placeholder="Any">
                                </p-multiSelect>
                              </ng-template>
                            </p-columnFilter>
                          }
                          <!-- DUE DAY SLOT -->
                          @case ('dueDaySlot') {
                            <p-columnFilter
                              field="dueDaySlot"
                              matchMode="equals"
                              display="menu"
                              [showMatchModes]="true"
                              [showOperator]="false"
                              [showAddButton]="false">
                              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown
                                  [ngModel]="value"
                                  [options]="dueDaySlots"
                                  (onChange)="filter($event.value)"
                                  placeholder="Any">
                                </p-dropdown>
                              </ng-template>
                            </p-columnFilter>
                          }
                          <!-- RATE TYPE -->
                          @case ('rateTypeCode') {
                            <p-columnFilter
                              field="rateTypeCode"
                              matchMode="equals"
                              display="menu"
                              [showMatchModes]="true"
                              [showOperator]="false"
                              [showAddButton]="false">
                              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown
                                  [ngModel]="value"
                                  [options]="rateTypes"
                                  (onChange)="filter($event.value)"
                                  placeholder="Any">
                                </p-dropdown>
                              </ng-template>
                            </p-columnFilter>
                          }
                          <!-- DESCRIPTION TYPE -->
                          @case ('descriptionTypeCode') {
                            <p-columnFilter
                              field="descriptionTypeCode"
                              matchMode="equals"
                              display="menu"
                              [showMatchModes]="true"
                              [showOperator]="false"
                              [showAddButton]="false">
                              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown
                                  [ngModel]="value"
                                  [options]="descriptionTypes"
                                  (onChange)="filter($event.value)"
                                  placeholder="Any">
                                </p-dropdown>
                              </ng-template>
                            </p-columnFilter>
                          }
                          <!-- ================= DEFAULT FILTERS ================= -->
                          @default {
                            @switch (col.filterType) {
                              <!-- DATE -->
                              @case ('date') {
                                <p-columnFilter
                                  [field]="col.field"
                                  type="date"
                                  display="menu"
                                  [showMatchModes]="false"
                                  [showOperator]="false"
                                  [showAddButton]="false"
                                  [showClearButton]="false"
                                  [showApplyButton]="false">
                                  <ng-template pTemplate="filter">
                                    <p-dropdown
                                      [options]="matchModeOptionsDate"
                                      [(ngModel)]="filterDatesMatchModes[col.field]"
                                      (onChange)="onDateFilterChange(col.field)">
                                    </p-dropdown>
                                    <p-calendar
                                      [(ngModel)]="filterDates[col.field]"
                                      [selectionMode]="filterDatesMatchModes[col.field] === 'betweenDate' ? 'range' : 'single'"
                                      [readonlyInput]="true">
                                    </p-calendar>
                                    <div class="flex items-center" style="float:right">
                                      <button class="btn btn-primary" pTooltip="Apply date filter" appActionTooltip
                                      (click)="applyDatesFilter(col.field)">Apply</button>
                                      <button class="btn btn-danger" pTooltip="Clear date filter" appActionTooltip
                                      (click)="clearDatesFilter(col.field)">Clear</button>
                                    </div>
                                  </ng-template>
                                </p-columnFilter>
                              }
                              <!-- BOOLEAN -->
                              @case ('boolean') {
                                <p-columnFilter
                                  [field]="col.field"
                                  matchMode="equals"
                                  display="menu"
                                  [showMatchModes]="false"
                                  [showOperator]="false"
                                  [showAddButton]="false"
                                  [showClearButton]="true"
                                  [showApplyButton]="true">
                                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-dropdown
                                      [ngModel]="value"
                                      [options]="approvalRequiredList"
                                      (onChange)="filter($event.value)"
                                      placeholder="Any">
                                    </p-dropdown>
                                  </ng-template>
                                </p-columnFilter>
                              }
                              <!-- NUMERIC -->
                              @case ('numeric') {
                                <p-columnFilter
                                  type="numeric"
                                  [field]="col.field"
                                  display="menu"
                                  [useGrouping]="false"
                                  [showOperator]="false"
                                  [showAddButton]="false">
                                </p-columnFilter>
                              }
                              <!-- TEXT (Default) -->
                              @default {
                                <p-columnFilter
                                  type="text"
                                  [field]="col.field"
                                  matchMode="contains"
                                  display="menu"
                                  [showOperator]="false"
                                  [showAddButton]="false">
                                </p-columnFilter>
                              }
                            }
                          }
                        }
                      </div>
                    </th>
                  }
                }
              </tr>
            </ng-template>
            <!-- ================= BODY ================= -->
            <ng-template pTemplate="body" let-tasks let-columns="columns">
              <tr>
                <!-- ACTIONS -->
                <td>
                  <div class="flex align-items-center gap-3">
                    <!-- Notifications -->
                                    <div class="notification-wrapper" [ngClass]="{
                            'has-notifications': tasks.unreadReminderNotificationCount > 0,
                            'no-notifications': tasks.unreadReminderNotificationCount === 0
                        }" (click)="tasks.unreadReminderNotificationCount > 0 && openReminderNotificationDialog(tasks)"
                      [pTooltip]="tasks.unreadReminderNotificationCount > 0 ? 'View Notifications' : 'No Notifications'" appActionTooltip>
                      <i class="mdi mdi-bell-outline notification-icon"></i>
                      @if (tasks.unreadReminderNotificationCount > 0) {
                        <span class="notification-badge"
                          >
                          {{ tasks.unreadReminderNotificationCount }}
                        </span>
                      }
                    </div>
                    <!-- Manage Reminder -->
                    @if (colsView.showCreateReminder) {
                      <span appActionTooltip [pTooltip]="tasks.disableManageReminders ? tasks.disableManageRemindersTitle : 'Manage Reminders'" [actionDisabled]="tasks.disableManageReminders">
                        <button class="btn btn-danger btn-sm"
                          (click)="openReminderDialog(tasks)" [disabled]="tasks.disableManageReminders">
                          <i class="mdi mdi-bell-plus"></i>
                        </button>
                      </span>
                    }
                    <!-- View -->
                    @if (viewflag) {
                      <button class="btn btn-info btn-sm" (click)="viewTask(tasks)"
                        pTooltip="View Task" appActionTooltip>
                        <i class="mdi mdi-eye"></i>
                      </button>
                    }
                    <!-- Assign -->
                    @if (tasks.showAssignTask) {
                      <span appActionTooltip [pTooltip]="tasks.disableAssignTask ? tasks.disableAssignTaskTitle : 'Assign To TK'" [actionDisabled]="tasks.disableAssignTask">
                        <button class="btn btn-warning btn-sm"
                          (click)="openAssignTask(tasks)" [disabled]="tasks.disableAssignTask">
                          <i class="mdi mdi-account-plus"></i>
                        </button>
                      </span>
                    }
                    <!-- Accept / Reject -->
                    @if (tasks.showAcceptRejectTask) {
                      <button class="btn btn-info btn-sm"
                        (click)="openAcceptTask(tasks)" pTooltip="Accept/Reject Task" appActionTooltip>
                        <i class="mdi mdi-clipboard-check-outline"></i>
                      </button>
                    }
                    <!-- Add TR -->
                    @if (tasks.showAddTRTask) {
                      <span appActionTooltip [pTooltip]="tasks.disableAddTRTask ? tasks.disableAddTRTaskTitle : 'Add Time Record'" [actionDisabled]="tasks.disableAddTRTask">
                        <button class="btn btn-info btn-sm"
                          (click)="openAddTR(tasks)" [disabled]="tasks.disableAddTRTask">
                          <i class="mdi mdi-clock-outline"></i>
                        </button>
                      </span>
                    }
                    <!-- Reassign -->
                    @if (tasks.showAssignTask) {
                      <span appActionTooltip [pTooltip]="tasks.disableAssignTask ? tasks.disableAssignTaskTitle : 'Reassign Task'" [actionDisabled]="tasks.disableAssignTask">
                        <button class="btn btn-primary btn-sm"
                          (click)="openAssignTask(tasks, false, true)"
                          [disabled]="tasks.disableAssignTask">
                          <i class="mdi mdi-account-switch"></i>
                        </button>
                      </span>
                    }
                    <!-- Comments -->
                    <button class="btn btn-secondary btn-sm" (click)="openComments(tasks)"
                      pTooltip="View Comments" appActionTooltip>
                      <i class="mdi mdi-comment-outline"></i>
                    </button>
                    <!-- For Approval -->
                    @if (colsView.showForApproval) {
                      <span appActionTooltip [pTooltip]="tasks.disableForApproval ? tasks.disableForApprovalTitle : 'For Approval'" [actionDisabled]="tasks.disableForApproval">
                        <button class="btn btn-info btn-sm"
                          (click)="forApproval(tasks)" [disabled]="tasks.disableForApproval">
                          <i class="mdi mdi-check-circle"></i>
                        </button>
                      </span>
                    }
                    <!-- Delete -->
                    @if (colsView.showDeleteTask) {
                      <span appActionTooltip [pTooltip]="tasks.disableDeleteTask ? tasks.disableDeleteTaskTitle : 'Delete Task'" [actionDisabled]="tasks.disableDeleteTask">
                        <button class="btn btn-danger btn-sm"
                          (click)="openDeleteTaskPopup(tasks)" [disabled]="tasks.disableDeleteTask">
                          <i class="mdi mdi-trash-can"></i>
                        </button>
                      </span>
                    }
                    <!-- Clone -->
                    @if (colsView.showCloneTask) {
                      <span appActionTooltip [pTooltip]="tasks.disableCloneTask ? tasks.disableCloneTaskTitle : 'Clone Task'" [actionDisabled]="tasks.disableCloneTask">
                        <button class="btn btn-success btn-sm"
                          (click)="cloneTask(tasks)" [disabled]="tasks.disableCloneTask">
                          <i class="mdi mdi-content-copy"></i>
                        </button>
                      </span>
                    }
                  </div>
                </td>
                <!-- STATIC DATA -->
                <td>{{ tasks.projectName }}</td>
                <td>
                  <a
                    href="#" (click)="$event.preventDefault(); clicked(tasks)" pTooltip="Open task details" appActionTooltip>
                    {{ tasks.taskName }}
                  </a>
                  <!-- <span *ngIf="!userrole.includes('LPC') && !userrole.includes('ADMIN')">
                  {{ tasks.taskName }}
                </span> -->
              </td>
              <td>{{ tasks.id }}</td>
              <!-- DYNAMIC DATA -->
              @for (col of columns; track col) {
                @if (col.visible) {
                  <td>
                    <div class="wrap-col-text">
                      @switch (col.field) {
                        @case ('stateCode') {
                          {{ tasks.stateDesc }}
                        }
                        @default {
                          {{ tasks[col.field] }}
                        }
                      }
                      @if (col.showHistoryIcon == true) {
                        <ng-container
                        *ngTemplateOutlet="historyTemplate;"></ng-container>
                      }
                      <ng-template #historyTemplate >
                        <span class="history-icon" pTooltip="View audit history" appActionTooltip>
                                                <i class="mdi mdi-history" [ngStyle]="{
                                                  'color':'var(--al-success)' ,
                                                  'opacity': 1 ,
                                                  'cursor': 'pointer'
                                               }"  (click)="showAuditData(tasks, col.field, col.header)"
                            tabindex="0">
                          </i>
                        </span>
                      </ng-template>
                    </div>
                  </td>
                }
              }
            </tr>
          </ng-template>
          <!-- ================= EMPTY ================= -->
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns?.length + 3">
                {{ gridErrorMessage || 'No records found' }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
    <ng-template #taskRecordIdentity>
      <div class="tw-record-identity">
        <div class="tw-record-titlerow">
          <div class="tw-record-title">{{ taskForm.get('taskName')?.value || title }}</div>
          @if (!taskAssignDialog && taskForm.get('id')?.value) {
            <button type="button" class="tw-record-id" (click)="copyTaskId(taskForm.get('id')?.value)"
              [attr.aria-label]="'Copy task ID ' + taskForm.get('id')?.value"
              pTooltip="Copy task ID" appActionTooltip>
              {{ taskIdCopied ? 'Copied!' : '#' + taskForm.get('id')?.value }}
              @if (!taskIdCopied) {
                <i class="mdi mdi-content-copy" aria-hidden="true"></i>
              }
            </button>
            <span class="visually-hidden" aria-live="polite">{{ taskIdCopied ? 'Task ID copied' : '' }}</span>
          }
        </div>
        <div class="tw-record-line" [class.is-inline]="!taskAssignDialog">
        @if (taskForm.get('orgName')?.value || taskForm.get('matterName')?.value) {
          <div class="tw-record-context">
            @if (taskForm.get('orgName')?.value) {
              <span><span class="tw-record-key">Organization Name</span> {{ taskForm.get('orgName')?.value }}</span>
            }
            @if (taskForm.get('matterName')?.value) {
              <span><span class="tw-record-key">Matter Name</span> {{ taskForm.get('matterName')?.value }}</span>
            }
          </div>
        }
        <div class="tw-record-meta" [class.tw-record-meta-assign]="taskAssignDialog">
          @if (taskAssignDialog) {
            @if (taskForm.get('taskTypeCode')?.value) {
              <span class="tw-record-chip">{{ taskForm.get('taskTypeCode')?.value }}</span>
            }
            @if (taskForm.get('id')?.value) {
              <span class="tw-record-pair">
                <span class="tw-record-key">Task</span>
                <span class="tw-record-val">#{{ taskForm.get('id')?.value }}</span>
              </span>
            }
            @if (wsEstimateText()) {
              <span class="tw-record-pair">
                <span class="tw-record-key">Est</span>
                <span class="tw-record-val">{{ wsEstimateText() }}</span>
              </span>
            }
            <span class="tw-record-due">
              <i class="mdi mdi-calendar-clock" aria-hidden="true"></i>
              <span class="tw-record-key">Due</span>
              <span class="tw-record-due-value">{{ assignmentDueDateText() }}</span>
              <span class="tw-record-due-sep"></span>
              <button type="button" class="history-icon tw-record-due-history"
                aria-label="View Due Date audit history"
                pTooltip="View audit history" appActionTooltip
                (click)="showAuditData(taskForm.getRawValue(), 'taskDueDate', 'Due Date')">
                <i class="mdi mdi-history" aria-hidden="true"></i>
              </button>
            </span>
            @if (taskForm.get('progress')?.value) {
              <span class="tw-record-pair">
                <span class="tw-record-key">Progress</span>
                <span class="tw-record-val">{{ taskForm.get('progress')?.value }}</span>
              </span>
            }
            @if (viewOnly) {
              <span class="tw-ro-badge">
                <i class="mdi mdi-lock-outline" aria-hidden="true"></i>
                Read-only view
              </span>
            }
            <span class="tw-record-meta-sep"></span>
            <button type="button" class="tw-assignment-details-toggle"
              [attr.aria-expanded]="assignmentDetailsExpanded"
              aria-controls="assignmentTaskContextCard"
              (click)="assignmentDetailsExpanded = !assignmentDetailsExpanded">
              <i class="mdi mdi-file-document-outline" aria-hidden="true"></i>
              Task details
              <i class="mdi" [ngClass]="assignmentDetailsExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                aria-hidden="true"></i>
            </button>
          } @else {
            @if (taskForm.get('taskTypeCode')?.value) {
              <span class="tw-record-meta-item">{{ taskForm.get('taskTypeCode')?.value }}</span>
            }
            @if (wsEstimateText()) {
              <span class="tw-record-meta-item"><span class="tw-meta-key">Est</span> <span class="tw-meta-val">{{ wsEstimateText() }}</span></span>
            }
            @if (taskForm.get('progress')?.value) {
              <span class="tw-record-meta-item"><span class="tw-meta-key">Progress</span> <span class="tw-meta-val">{{ taskForm.get('progress')?.value }}</span></span>
            }
            @if (viewOnly) {
              <span class="tw-ro-badge">Read-only view</span>
            }
          }
          @if (taskForm.dirty && !viewOnly) {
            <span class="tw-dirty-badge">Unsaved changes</span>
          }
        </div>
        </div>
      </div>
    </ng-template>

    @if (showProjectsView) {
      <div class="tw-detail-view">
        <app-notification [errorMsg]="errorMsg"></app-notification>
        @if (loading) {
          <div class="loader">
            <div class="spinner"></div>
          </div>
        }
        <header class="tw-detail-record-header">
          <nav class="tw-record-breadcrumb" aria-label="Task breadcrumb">
            <a href="#" class="tw-breadcrumb-link" (click)="$event.preventDefault(); backToTasksGrid()">Tasks</a>
            <i class="mdi mdi-chevron-right" aria-hidden="true"></i>
            <span>{{ taskForm.get('projectName')?.value }}</span>
          </nav>
          <div class="tw-record-header-row">
            <ng-container *ngTemplateOutlet="taskRecordIdentity"></ng-container>
            <div class="tw-record-actions">
              @if (viewOnly) {
                @if (canAcceptCurrentDisbursementTask()) {
                  <button type="button" class="tw-hdr-btn tw-hdr-btn-primary" pTooltip="Accept this task"
                    appActionTooltip (click)="openCurrentTaskAcceptance()">
                    <i class="mdi mdi-check"></i> Accept Task
                  </button>
                }
                <span appActionTooltip [actionTooltipDelay]="0" [pTooltip]="selectedTask.disableEditTask ? selectedTask.disableEditTaskTitle : 'Edit Task'" [actionDisabled]="selectedTask.disableEditTask">
                  <button type="button" class="tw-hdr-btn tw-hdr-btn-primary" (click)="editTaskInDetailedView()"
                    [disabled]="selectedTask.disableEditTask">
                    <i class="mdi mdi-pencil"></i> Edit Task
                  </button>
                </span>
              } @else {
                <button type="button" class="tw-hdr-btn tw-hdr-btn-text" pTooltip="Cancel" appActionTooltip (click)="requestCloseTaskDialog()">
                  Cancel
                </button>
                <button type="button" class="tw-hdr-btn tw-hdr-btn-primary" pTooltip="Update task" appActionTooltip (click)="saveTask()">
                  Update Task
                  @if (btnLoading) {
                    <i class="fa fa-solid fa-sync fa-spin ms-1"></i>
                  }
                </button>
              }
            </div>
          </div>
        </header>
    <p-tabView [cache]="false" styleClass="tw-detail-tabs">
      <p-tabPanel header="Selected Task Details">
        <div class="card task-details tw-detail-task">
          <ng-container *ngTemplateOutlet="taskEditTemplate"></ng-container>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Task Level Time Records">
        <app-time-record-grid [tasksgridTaskFilter]="selectedTask?.id"></app-time-record-grid>
      </p-tabPanel>
      <!-- <p-tabPanel header="Users">
      <app-users-grid></app-users-grid>
    </p-tabPanel> -->
  </p-tabView>
</div>
}

</div>
</div>
</div>

<!-- Common Task Edit/View Template -->
<ng-template #taskEditTemplate>
  <form [formGroup]="taskForm">
    @if (!manageDisbursementsDialog) {
      <div class="card">
        <div class="card-body tw-body" [class.tw-rail-collapsed]="notesRailCollapsed">

          <div class="tw-form">

            <div class="tw-identity">
              <div class="row">
            <div class="col-12 col-md-6 col-xl-6 col-xxl-4">
              <div class="mb-1">
                <label for="taskName" class="form-label mb-1">Task Name
                  @if (getFieldInfo('taskName'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="taskName" id="taskName" appSpellCheck>
              </div>
            </div>
            <div class="col-12 col-md-6 col-xl-6 col-xxl-4">
              <div class="mb-1">
                <label for="projectName" class="form-label mb-1">Project Name
                  @if (getFieldInfo('projectName'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="projectName"
                  id="projectName">
              </div>
            </div>
              </div>
            </div>

            <div class="tw-section tw-vitals"
              [class.tw-vitals-empty-assignment]="taskAssignDialog && !viewTaskAssignmentDialog && disbursementTaskDialog && !assignmentDetailsExpanded">
              <div class="tw-section-label">Vitals</div>
              <div class="row">
            @if (!taskAssignDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-1">
                  <label for="statusCode" class="form-label mb-1">Task Status
                    <span class="history-icon"
                      pTooltip="View audit history" appActionTooltip>
                                        <i class="mdi mdi-history" [ngStyle]="{
                                                                  color: 'var(--al-success)',
                                                                  opacity: 1,
                                                                  cursor: 'pointer'
                                                                }" (click)="showAuditData(taskForm.getRawValue(), 'statusCode', 'Due Date')"
                      tabindex="0"></i>
                    </span>
                    @if (getFieldInfo('statusCode'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                    @if (canShowNotReadyButton) {
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger ms-2 py-0 px-2 align-baseline"
                        (click)="onNotReadyClick()"
                        pTooltip="Send task back to Not Ready" appActionTooltip>
                        Not Ready
                      </button>
                    }
                  </label>
                  <input
                     readonly 
                    class="form-control p-2"
                    type="text"
                    formControlName="statusCode"
                    id="statusCode_text">
                </div>
              </div>
            }
                <div class="col-12 col-md-6 col-xl-4 col-xxl-3"
                  [class.tw-assignment-due-field]="taskAssignDialog && !viewTaskAssignmentDialog && !assignmentDetailsExpanded">
                  <div class="mb-1">
                    <label for="taskDueDate" class="form-label mb-1">Due Date
                      <span class="history-icon"
                        pTooltip="View audit history" appActionTooltip>
                                        <i class="mdi mdi-history" [ngStyle]="{
                                                                  color: 'var(--al-success)',
                                                                  opacity: 1,
                                                                  cursor: 'pointer'
                                                                }" (click)="showAuditData(taskForm.getRawValue(), 'taskDueDate', 'Due Date')"
                        tabindex="0"></i>
                      </span>
                      @if (getFieldInfo('taskDueDate'); as info) {
                        @if (info.showInformation === 'Yes' && info.informationText) {
                          <info-tooltip [infoText]="info.informationText"></info-tooltip>
                        }
                      }
                    </label><span
                  style="color:var(--al-danger);">*</span>
                  <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                    yearRange="2010:2030" dateFormat="mm/dd/yy" formControlName="taskDueDate"
                    (onSelect)="isValidDueDate()" [style]="{'width':'100%'}">
                  </p-calendar>
                  @if (wsOverdueText()) {
                    <div class="tw-overdue">{{ wsOverdueText() }}</div>
                  }
                  <!-- <span style="color:var(--al-danger)" *ngIf="dueDateMaxError && !dueDateMinError">Due Date cannot exceed Project Due Date {{taskForm.getRawValue().projectDueDate}} </span>
                  <span style="color:var(--al-danger)" *ngIf="dueDateMinError && !dueDateMaxError">Due Date cannot be less than task Created Date {{taskForm.getRawValue().createdOn}} </span> -->
                  <!-- <span style="color:var(--al-danger)" *ngIf="dueDateError">Due Date should be in the range of
                {{taskForm.getRawValue().createdOn}} - {{taskForm.getRawValue().projectDueDate}} </span> -->
                @if (dueDateError) {
                  <span style="color:var(--al-danger)">Due Date should be after Task Created Date [
                  {{taskForm.getRawValue().createdOn}}]  </span>
                }
                @if (dueDateExceeded) {
                  <span style="color:var(--al-success)">Project Due Date Extended [
                  {{taskForm.getRawValue().taskDueDate}}]  </span>
                }
                @if (submitted && !dueDateError && taskDueDate && taskDueDate.invalid) {
                  <span style="color:var(--al-danger)"
                    >Due
                  Date is required</span>
                }
              </div>
            </div>
          @if (!disbursementTaskDialog) {
            <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
              <div class="mb-1">
                <label for="reviewStatus" class="form-label mb-1">Review Status
                  <span class="history-icon"
                    pTooltip="View audit history" appActionTooltip>
                                        <i class="mdi mdi-history" [ngStyle]="{
                                                                  color: 'var(--al-success)',
                                                                  opacity: 1,
                                                                  cursor: 'pointer'
                                                                }" (click)="showAuditData(taskForm.getRawValue(), 'reviewStatus', 'Review Status')"
                    tabindex="0"></i>
                  </span>
                  @if (getFieldInfo('reviewStatus'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <select class="form-select" formControlName="reviewStatus">
                  <option [value]="" selected>Select</option>
                  @for (status of reviewstatuslist; track status) {
                    <option [ngValue]="status.value"
                      [selected]="status.value == taskForm.getRawValue().reviewStatus">{{status.label}}
                    </option>
                  }
                </select>
              </div>
            </div>
          }
          @if (!taskAssignDialog && !disbursementTaskDialog) {
            <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
              <div class="mb-1">
                <label for="approver" class="form-label mb-1">Task Approver
                  @if (getFieldInfo('approver'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                  </label><span style="color:var(--al-danger);">*</span>
                  <p-dropdown
                    formControlName="approver"
                    [options]="lpcUsersList"
                    optionLabel="mainEmail"
                    optionValue="id"
                    [showClear]="true"
                    [filter]="true"
                    [style]="{'width':'100%'}"
                    placeholder="Select Task Approver">
                  </p-dropdown>
                  @if (submitted && approver && approver.invalid) {
                    <span style="color:var(--al-danger)">
                    Task Approver is required</span>
                  }
                </div>
              </div>
            }
            @if (!taskAssignDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-1">
                  <label for="isCompleted" class="form-label mb-1">Task Completed
                    <span class="history-icon"
                      pTooltip="View audit history" appActionTooltip>
                                        <i class="mdi mdi-history" [ngStyle]="{
                                                                  color: 'var(--al-success)',
                                                                  opacity: 1,
                                                                  cursor: 'pointer'
                                                                }" (click)="showAuditData(taskForm.getRawValue(), 'isCompleted', 'Task Completed')"
                      tabindex="0"></i>
                    </span>
                    @if (getFieldInfo('isCompleted'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <div class="locked-field">
                    <select formControlName="isCompleted" id="isCompleted" class="form-select">
                      <option value="" selected>Select</option>
                      <option value="Yes" selected>Yes</option>
                      <option value="No" selected>No</option>
                    </select>
                    @if (taskForm.get('isCompleted')?.disabled) {
                      <i class="mdi mdi-lock locked-field-icon" tabindex="0"
                        aria-label="Editable only when the task's status is Approved or Ready to Complete."
                        pTooltip="Editable only when the task's status is Approved or Ready to Complete."
                        tooltipPosition="top"></i>
                    }
                  </div>
                </div>
              </div>
            }
                @if (!taskAssignDialog && disbursementTaskDialog) {
                  <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                    <div class="mb-3">
                      <label class="form-label">Disbursement Amount
                        @if (getFieldInfo('disbursementAmount'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                        </label> <span style="color:var(--al-danger);">*</span>
                        <input class="form-control" type="number" formControlName="disbursementAmount" step="0.01" min="0" />
                        @if (submitted && taskForm.get('disbursementAmount').invalid) {
                          <span style="color:var(--al-danger)">Disbursement Amount
                          is required</span>
                        }
                      </div>
                    </div>
                  }
                @if (!taskAssignDialog && disbursementTaskDialog) {
                  <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                    <div class="mb-3">
                      <label class="form-label">Date Paid
                        @if (getFieldInfo('datePaid'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                        </label> <span style="color:var(--al-danger);">*</span>
                        <p-calendar formControlName="datePaid" dateFormat="mm/dd/yy" [maxDate]="today" appendTo="body" [style]="{'width':'100%'}"></p-calendar>
                        @if (submitted && taskForm.get('datePaid').invalid) {
                          <span style="color:var(--al-danger)">Date Paid
                          is required</span>
                        }
                      </div>
                    </div>
                  }
              </div>
            </div>

            @if (taskAssignDialog || enableDeleteTask || enableReassignTask) {
              <div class="tw-section">
                <div class="tw-section-label">Assignment</div>
                <div class="row">
        @if (taskAssignDialog || enableDeleteTask) {
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
            <div class="mb-1">
              <label for="stateDesc" class="form-label mb-1">State
                @if (getFieldInfo('stateDesc'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" formControlName="stateDesc"
                id="stateDesc">
            </div>
          </div>
        }
        @if (taskAssignDialog && viewTaskAssignmentDialog) {
          <div class="col-12 col-md-6 col-xl-3 col-xxl-2">
            <div class="form-check mb-1">
              <input class="form-check-input" id="isIncludeToday" type="checkbox" [(checked)]="includeToday"
                disabled>
              <label class="form-check-label" for="isIncludeToday">
                Include Today
                @if (getFieldInfo('isIncludeToday'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
            </div>
          </div>
        }
                </div>
              </div>
            }

            <div class="tw-section">
              <div class="tw-section-label">Task details</div>
              <div class="row">
          <div class="col-12">
            <div class="mb-1">
              <label for="description" class="form-label mb-1">Description
                @if (getFieldInfo('description'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <textarea class="form-control p-2" formControlName="description"
              id="description" appSpellCheck></textarea>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-1">
              <label for="orgNotes" class="form-label mb-1">Organization Notes
                @if (getFieldInfo('orgNotes'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <textarea class="form-control p-2" disabled formControlName="orgNotes"
              id="orgNotes" appSpellCheck></textarea>
            </div>
          </div>
        @if (!taskAssignDialog && !disbursementTaskDialog && taskForm.get('taskInstructions')?.value) {
          <div class="col-12">
            <div class="mb-3">
              <div class="tw-instructions">
                <span class="tw-instructions-tag">TASK INSTRUCTIONS</span>
                <div class="card-body">
                  <div class="task-instructions-content" [innerHTML]="taskForm.get('taskInstructions')?.value"></div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (!taskAssignDialog && !disbursementTaskDialog) {
          <div class="col-12">
            <div class="mb-1">
              @if (!viewOnly) {
                <label for="driveLink" class="form-label mb-1">One Drive Link
                  @if (getFieldInfo('driveLink'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
              }
              @if (viewOnly) {
                <label class="form-label mb-1">One Drive Link
                  @if (getFieldInfo('driveLink'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <div class="tw-link-value">
                  @if (taskForm.get('driveLink')?.value) {
                    <a [href]="taskForm.get('driveLink')?.value" target="_blank" rel="noopener"
                      [title]="taskForm.get('driveLink')?.value">Open link</a>
                  } @else {
                    <span class="tw-value-empty">Not Available</span>
                  }
                </div>
              }
              @if (!viewOnly) {
                <textarea placeholder="" class="form-control" formControlName="driveLink" appSpellCheck></textarea>
              }
            </div>
          </div>
        }
          @if (isEntityRelatedTask) {
            <div class="col-12 col-md-6 col-xl-6 col-xxl-6">
              <div class="mb-3">
                <div class="d-flex align-items-center mb-1">
                  <label for="entityId" class="form-label mb-0">
                    Entity <span class="text-danger">*</span>
                  </label>

                  @if (getFieldInfo('entityId'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText" class="ms-1"></info-tooltip>
                    }
                  }

                  @if (!viewOnly) {
                    <div class="d-flex gap-2 ms-2 fs-5">
                      <a
                        href="javascript:void(0)"
                        class="text-primary text-decoration-none d-inline-flex align-items-center dynamic-icon-btn"
                        (click)="openEntityDialog()"
                        pTooltip="Add New Entity" appActionTooltip>
                        <i class="mdi mdi-plus-circle-outline"></i>
                      </a>

                      @if (this.taskForm.get('entityId')?.value && this.entityService.entityToEdit && this.entityService.entityToEdit?.isTkUpdatedEntity !== 'Yes' && this.entityService.entityToEdit?.subjectEntityId == null) {
                        <a
                          href="javascript:void(0)"
                          class="text-primary text-decoration-none d-inline-flex align-items-center dynamic-icon-btn"
                          (click)="openEditEntityDialog()"
                          pTooltip="Edit Entity" appActionTooltip>
                          <i class="mdi mdi-pencil-outline"></i>
                        </a>
                      }
                    </div>
                  }
                </div>

                <div class="d-flex gap-2">
                  <p-dropdown class="flex-grow-1" formControlName="entityId" [options]="entitiesList" optionLabel="label"
                    optionValue="value" [showClear]="true" [filter]="true" appendTo="body" [style]="{'width':'100%'}"
                    placeholder="Select Entity">
                  </p-dropdown>
                </div>

                @if (taskForm.get('entityId')?.invalid && taskForm.get('entityId')?.touched) {
                  <div class="mt-1">
                    <small class="text-danger">
                      Entity is required
                    </small>
                  </div>
                }
              </div>
            </div>
          }
              </div>
            </div>

            @if (!taskAssignDialog && disbursementTaskDialog) {
              <div class="tw-section">
                <div class="tw-section-label">Payment &amp; disbursement</div>
                <div class="row">
        @if (!taskAssignDialog && disbursementTaskDialog) {
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
            <div class="mb-3">
              <label class="form-label">Transaction Type
                @if (getFieldInfo('transactionType'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
                </label><span style="color:var(--al-danger);">*</span>
                <select class="form-select" formControlName="transactionType">
                  <option value="" selected>Select</option>
                  @for (type of prefDisbursementTypes; track type) {
                    <option
                      [ngValue]="type"
                    [selected]="taskForm.getRawValue().transactionType == type">{{type}}</option>
                  }
                </select>
                @if (submitted && taskForm.get('transactionType').invalid) {
                  <span style="color:var(--al-danger)">Transaction Type
                  is required</span>
                }
              </div>
            </div>
          }
          @if (!taskAssignDialog && disbursementTaskDialog) {
            <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
              <div class="mb-3">
                <label class="form-label">Payment Method
                  @if (getFieldInfo('paymentMethod'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                  </label> <span style="color:var(--al-danger);">*</span>
                  <div class="locked-field">
                    <select class="form-select" formControlName="paymentMethod" >
                      <option value="" selected >Select Method </option>
                      @for (method of paymentMethodsList; track method) {
                        <option [value]="method.id">{{method.accountName }}</option>
                      }
                    </select>
                    @if (taskForm.get('paymentMethod')?.disabled) {
                      <i class="mdi mdi-lock locked-field-icon" tabindex="0"
                        aria-label="Not required for 'Credit Card on File'. Switch Transaction Type to Check, ACH, or Wire to choose a payment method."
                        pTooltip="Not required for 'Credit Card on File'. Switch Transaction Type to Check, ACH, or Wire to choose a payment method."
                        tooltipPosition="top"></i>
                    }
                  </div>
                  @if (submitted && taskForm.get('paymentMethod').invalid) {
                    <span style="color:var(--al-danger)">Payment Method
                    is required</span>
                  }
                </div>
              </div>
            }
            @if (!taskAssignDialog && disbursementTaskDialog && taskForm.get('transactionType').value=='Escrow') {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-3">
                  <label class="form-label">Escrow Client
                    @if (getFieldInfo('escrowAccountId'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                    </label> <span style="color:var(--al-danger);">*</span>
                    <select class="form-select" formControlName="escrowAccountId" >
                      <option value="" selected >Select Client </option>
                      @for (method of escrowList; track method) {
                        <option [value]="method.id">{{method.accountName }}</option>
                      }
                    </select>
                    @if (submitted && taskForm.get('escrowAccountId').invalid) {
                      <span style="color:var(--al-danger)">Escrow Client
                      is required</span>
                    }
                  </div>
                </div>
              }
              @if (!taskAssignDialog && disbursementTaskDialog) {
                <div class="col-12 col-md-6 col-xl-6 col-xxl-4">
                  <div class="mb-3">
                    <label class="form-label">Payee
                      @if (getFieldInfo('payee'); as info) {
                        @if (info.showInformation === 'Yes' && info.informationText) {
                          <info-tooltip [infoText]="info.informationText"></info-tooltip>
                        }
                      }
                      </label> <span style="color:var(--al-danger);">*</span>
                      <p-dropdown
                        class="form-select-wrapper"
                        formControlName="payee"
                        [options]="vendorList"
                        optionLabel="name"
                        optionValue="id"
                        [showClear]="true"
                        [filter]="true"
                        [style]="{'width':'100%'}"
                        placeholder="Select">
                      </p-dropdown>
                      @if (submitted && taskForm.get('payee').invalid) {
                        <span style="color:var(--al-danger)">Payee
                        is required</span>
                      }
                    </div>
                  </div>
                }
                @if (!taskAssignDialog && disbursementTaskDialog) {
                  <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                    <div class="mb-3">
                      <label class="form-label">Payee – Invoice Number
                        @if (getFieldInfo('payeeInvoiceNumber'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                      </label>
                      <input class="form-control" type="text" formControlName="payeeInvoiceNumber" />
                    </div>
                  </div>
                }
                @if (!taskAssignDialog && disbursementTaskDialog) {
                  <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                    <div class="mb-3">
                      <label class="form-label">Payment Reference Number
                        @if (getFieldInfo('paymentReferenceNumber'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                      </label>
                      <input class="form-control" type="text" formControlName="paymentReferenceNumber" />
                    </div>
                  </div>
                }
                @if (!taskAssignDialog && disbursementTaskDialog) {
                  <div class="col-12 col-md-6 col-xl-3 col-xxl-2">
                    <div class="mb-3">
                      <label class="form-label">Receipt
                        @if (getFieldInfo('receipt'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                      </label>
                      <select class="form-select" formControlName="receipt">
                        <option value="" selected>Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                }
                  <!-- <div class="col-xl-4" *ngIf="!taskAssignDialog && disbursementTaskDialog">
                  <div class="mb-3">
                    <label class="form-label">Date Settled</label>
                    <p-calendar formControlName="dateSettled" dateFormat="mm/dd/yy" appendTo="body"></p-calendar>
                  </div>
                </div> -->
                </div>
              </div>
            }

            <p-accordion [multiple]="true" styleClass="tw-accordion">
              @if (!disbursementTaskDialog) {
                <p-accordionTab [selected]="!(taskAssignDialog && !enableDeleteTask)">
                  <ng-template pTemplate="header">
                    <span class="tw-acc-title">Time &amp; estimate</span>
                    <span class="tw-acc-summary">{{ timeSectionSummary() }}</span>
                  </ng-template>
                  <div class="row tw-fields-grid tw-time-grid">
            @if (!taskAssignDialog && !disbursementTaskDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-1">
                  <label for="actualTime" class="form-label mb-1">Actual Time(HH:MM)
                    @if (getFieldInfo('actualTime'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <input class="form-control p-2" type="text"  formControlName="actualTime"
                    id="actualTime">
                </div>
              </div>
            }
                @if (!disbursementTaskDialog) {
                  <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                    <div class="mb-1">
                      <label for="timeEstimate" class="form-label mb-1">Estimated Time(HH:MM)
                        @if (getFieldInfo('timeEstimate'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                      </label>
                      <span style="color:var(--al-danger);">*</span>
                      <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24" [timeOnly]="true"
                        formControlName="timeEstimate" [defaultDate]="defaultTime" [style]="{'width':'100%'}">
                      </p-calendar>
                      @if (submitted && timeEstimate && timeEstimate.invalid) {
                        <span style="color:var(--al-danger)"
                          >Estimated Time
                        is required</span>
                      }
                    </div>
                  </div>
                }
                @if ((lpcdashboard || !onlytk ) && !disbursementTaskDialog) {
                  <div [ngClass]="taskAssignDialog ? 'col-12 col-md-6 col-xl-3 col-xxl-2' : 'col-12 col-md-6 col-xl-4 col-xxl-3'">
                    <div class="mb-1">
                      <label for="maxTime" class="form-label mb-1">Max Time(HH:MM)
                        @if (getFieldInfo('maxTime'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                      </label>
                      <!-- <span style="color:var(--al-danger);">*</span> -->
                      <!-- <input class="form-control p-2" type="number" step="any" formControlName="maxTime"
                      id="maxTime"> -->
                      <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24" [timeOnly]="true"
                        formControlName="maxTime" [defaultDate]="defaultTime" [style]="{'width':'100%'}">
                      </p-calendar>
                      <!-- <p>{{maxTime}}{{maxTime.invalid}}</p> -->
                      @if (submitted && taskForm.get('maxTime').errors?.required) {
                        <span style="color:var(--al-danger)">Max Time
                        is required</span>
                      }
                    </div>
                  </div>
                }
          @if (!disbursementTaskDialog) {
            <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
              <div class="mb-1">
                <label for="progress" class="form-label mb-1">Task Progress
                  @if (getFieldInfo('progress'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="progress"
                  id="progress" readonly>
              </div>
            </div>
          }
            @if (!taskAssignDialog && !disbursementTaskDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-1">
                  <label class="form-label mb-1">Rate Type
                    @if (getFieldInfo('rateTypeCode'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <input class="form-control p-2" type="text" step="any" formControlName="rateTypeCode"
                    id="rateTypeCode">
                </div>
              </div>
            }
            @if (!taskAssignDialog && !disbursementTaskDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-1">
                  <label for="catEnforceMax" class="form-label mb-1">Catalogue Enforced Max Time
                    @if (getFieldInfo('catEnforceMax'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <input type="text" class="form-control p-2" readonly formControlName="catEnforceMax" />
                </div>
              </div>
            }
            @if (!taskAssignDialog && !disbursementTaskDialog) {
              <div class="col-12 col-md-6 col-xl-3 col-xxl-2">
                <div class="mb-1">
                  <label for="isEnforceMaximum" class="form-label mb-1">Enforced Max
                    Time
                    @if (getFieldInfo('isEnforceMaximum'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <select class="form-select" formControlName="isEnforceMaximum"  (change)="onEnforceMaxChange()">
                    <option [value]="" selected>Select</option>
                    <option value="Yes" selected>Yes</option>
                    <option value="No" selected>No</option>
                  </select>
                </div>
              </div>
            }
                @if (!disbursementTaskDialog) {
                  <div [ngClass]="taskAssignDialog ? 'col-12 col-md-6 col-xl-3 col-xxl-2' : 'col-12 col-md-6 col-xl-3 col-xxl-2'">
                    <div class="mb-1">
                      <label for="isRequireEstimate" class="form-label mb-1">Required Estimate
                        @if (getFieldInfo('isRequireEstimate'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                      </label><span
                    style="color:var(--al-danger);">*</span>
                    <select class="form-select" id="isRequireEstimate" formControlName="isRequireEstimate">
                      <option value="" selected>Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                    @if (submitted && isRequireEstimate && isRequireEstimate.invalid) {
                      <span style="color:var(--al-danger)"
                        >Required
                        Estimate is
                      required</span>
                    }
                  </div>
                </div>
              }
              @if (!taskAssignDialog && !disbursementTaskDialog) {
                <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                  <div class="mb-1">
                    <label for="consolidatedTimeRecords" class="form-label mb-1">Consolidated Time
                      Records
                      @if (getFieldInfo('consolidatedTimeRecords'); as info) {
                        @if (info.showInformation === 'Yes' && info.informationText) {
                          <info-tooltip [infoText]="info.informationText"></info-tooltip>
                        }
                      }
                      </label><span style="color:var(--al-danger);">*</span>
                      <select  class="form-select" id="consolidatedTimeRecords" formControlName="consolidatedTimeRecords" >
                        <option value="" selected>Select</option>
                        <option value="Yes" >Yes</option>
                        <option value="No" >No</option>
                      </select>
                      @if (submitted && consolidatedTimeRecords && consolidatedTimeRecords.invalid) {
                        <span style="color:var(--al-danger)"
                          >Consolidated
                          Time Records is
                        required</span>
                      }
                    </div>
                  </div>
                }
        @if (!taskAssignDialog && !disbursementTaskDialog) {
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
            <div class="mb-1">
              <label for="holdTimeUntilComp" class="form-label mb-1">Hold Time Until
                Completed
                @if (getFieldInfo('holdTimeUntilComp'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
                </label><span style="color:var(--al-danger);">*</span>
                <select class="form-select" id="holdTimeUntilComp" formControlName="holdTimeUntilComp">
                  <option value="" selected>Select</option>
                  <option value="Yes" >Yes</option>
                  <option value="No" >No</option>
                </select>
                @if (submitted && holdTimeUntilComp && holdTimeUntilComp.invalid) {
                  <span style="color:var(--al-danger)"
                    >Hold
                    Time Until Completed is
                  required</span>
                }
              </div>
            </div>
          }
            @if (!taskAssignDialog && !disbursementTaskDialog) {
              <div class="col-12 col-md-6 col-xl-3 col-xxl-2">
                <div class="mb-1">
                  <label for="openEnded" class="form-label mb-1">Open Ended
                    @if (getFieldInfo('openEnded'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label><span
                style="color:var(--al-danger);">*</span>
                <select class="form-select" id="openEnded" formControlName="openEnded">
                  <option [value]="" selected>Select</option>
                  <option value="Yes" >Yes</option>
                  <option value="No" >No</option>
                </select>
                @if (submitted && openEnded && openEnded.invalid) {
                  <span style="color:var(--al-danger)">Open
                    Ended is
                  required</span>
                }
              </div>
            </div>
          }
          @if (!disbursementTaskDialog) {
            <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
              <div class="mb-1">
                <label for="dueDaySlot" class="form-label mb-1">Due Day Slot
                  @if (getFieldInfo('dueDaySlot'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <select class="form-select" id="dueDaySlot" formControlName="dueDaySlot">
                  <option [value]="" selected>Select</option>
                  <option value="Morning">Morning</option>
                  <option value="Afternoon">Afternoon</option>
                  <option value="Evening">Evening</option>
                </select>
              </div>
            </div>
          }
                  </div>
                </p-accordionTab>
              }
              @if (!disbursementTaskDialog) {
              <p-accordionTab [selected]="!(taskAssignDialog && !enableDeleteTask)">
                <ng-template pTemplate="header">
                  <span class="tw-acc-title">Billing</span>
                  <span class="tw-acc-summary">{{ billingSectionSummary() }}</span>
                </ng-template>
                <div class="row tw-fields-grid tw-billing-grid">
                @if (!taskAssignDialog && !disbursementTaskDialog) {
                  <div class="col-12 col-md-6 col-xl-3 col-xxl-2">
                    <div class="mb-1">
                      <label for="isBillable" class="form-label mb-1">Billable
                        @if (getFieldInfo('isBillable'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                      </label><span
                    style="color:var(--al-danger);">*</span>
                    <select class="form-select" id="isBillable" formControlName="isBillable">
                      <option [value]="" selected>Select</option>
                      <option value="Yes" >Yes</option>
                      <option value="No" >No</option>
                    </select>
                    @if (submitted && isBillable && isBillable.invalid) {
                      <span style="color:var(--al-danger)">Billable
                      is required</span>
                    }
                  </div>
                </div>
              }
          @if (!disbursementTaskDialog) {
            <div class="col-12 col-md-6 col-xl-6 col-xxl-4">
              <div class="mb-1">
                <label class="form-label">Non Billable Reason
                  @if (getFieldInfo('nonBillableReason'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                @if (isBillable.value=='No') {
                  <span style="color:var(--al-danger);">*</span>
                }
                <p-dropdown formControlName="nonBillableReason"
                                        [options]="[
                                            {label: 'Pre-Invoiced', value: 'Pre-Invoiced'},
                                            {label: 'Managed Service Project', value: 'Managed Service Project'},
                                            {label: 'Internal or Administrative Task', value: 'Internal or Administrative Task'},
                                            {label: 'Error Correction', value: 'Error Correction'},
                                            {label: 'Client Courtesy', value: 'Client Courtesy'},
                                            {label: 'Business Development', value: 'Business Development'},
                                            {label: 'Knowledge Management', value: 'Knowledge Management'},
                                            {label: 'Professional Development', value: 'Professional Development'},
                                            {label: 'Marketing and Thought Leadership', value: 'Marketing and Thought Leadership'},
                                            {label: 'Fixed Fee Project', value: 'Fixed Fee Project'}
                                        ]"
                  appendTo="body"
                  optionLabel="label"
                  optionValue="value"
                  [showClear]="true"
                  [filter]="true"
                  [style]="{'width':'100%'}"
                  placeholder="Select Non Billable Reason">
                </p-dropdown>
                @if (submitted && nonBillableReason && nonBillableReason.invalid) {
                  <span style="color:var(--al-danger)">Non Billable Reason is required</span>
                }
              </div>
            </div>
          }
              @if (!taskAssignDialog && !disbursementTaskDialog) {
                <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                  <div class="mb-1">
                    <label for="isApprovalRequired" class="form-label mb-1">Approval
                      Required
                      @if (getFieldInfo('isApprovalRequired'); as info) {
                        @if (info.showInformation === 'Yes' && info.informationText) {
                          <info-tooltip [infoText]="info.informationText"></info-tooltip>
                        }
                      }
                      </label><span style="color:var(--al-danger);">*</span>
                      <select class="form-select" id="isApprovalRequired" (change)="onIsApprovalRequiredChange($event)"
                        formControlName="isApprovalRequired">
                        <option value="" selected>Select</option>
                        <option value="Yes" >Yes</option>
                        <option value="No" >No</option>
                      </select>
                      @if (submitted && isApprovalRequired && isApprovalRequired.invalid) {
                        <span style="color:var(--al-danger)"
                          >Approval
                        Required is required</span>
                      }
                    </div>
                  </div>
                }
          <div class="col-12 col-md-6 col-xl-3 col-xxl-2">
            <div class="mb-1">
              <label for="isPreInvoiced" class="form-label mb-1">Pre-Invoiced
                @if (getFieldInfo('isPreInvoiced'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" readonly formControlName="isPreInvoiced"
                id="isPreInvoiced">
            </div>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
            <div class="mb-1">
              <label for="isPrePaid" class="form-label mb-1">Pre-Paid
                @if (getFieldInfo('isPrePaid'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" readonly formControlName="isPrePaid"
                id="isPrePaid">
            </div>
          </div>
                </div>
              </p-accordionTab>
              }
              @if (!disbursementTaskDialog) {
              <p-accordionTab [selected]="!(taskAssignDialog && !enableDeleteTask)">
                <ng-template pTemplate="header">
                  <span class="tw-acc-title">Classification &amp; scope</span>
                  <span class="tw-acc-summary">{{ classificationSectionSummary() }}</span>
                </ng-template>
                <div class="row tw-fields-grid tw-classification-grid">
            @if (!taskAssignDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-1">
                  <label for="taskTypeCode" class="form-label mb-1">Task Type
                    @if (getFieldInfo('taskTypeCode'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <input class="form-control p-2" type="text" readonly formControlName="taskTypeCode"
                    id="taskTypeCode">
                </div>
              </div>
            }
            @if (!disbursementTaskDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3" >
                <div class="mb-1">
                  <label for="practiceAreaCode" class="form-label mb-1">Practice Area
                    @if (getFieldInfo('practiceAreaCode'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <select class="form-select" readonly formControlName="practiceAreaCode">
                    <option value="" selected>Select</option>
                    @for (area of userTkPracticeAreas; track area) {
                      <option [ngValue]="area.description"
                        [selected]="area.description== taskForm.getRawValue().practiceAreaCode">{{area.description}}
                      </option>
                    }
                  </select>
                  <!-- <span style="color:var(--al-danger)" *ngIf="submitted && practiceAreaCode && practiceAreaCode.invalid">
                Practice Area is required</span> -->
              </div>
            </div>
          }
            @if (!taskAssignDialog  && !disbursementTaskDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-1">
                  <label for="disbursementRelated" class="form-label mb-1">Disbursement Related
                    @if (getFieldInfo('disbursementRelated'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <input class="form-control p-2" type="text" readonly formControlName="disbursementRelated"
                    id="disbursementRelated">
                </div>
              </div>
            }
            @if (!showCountry && !taskAssignDialog && !disbursementTaskDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-1">
                  <label for="countryRelated" class="form-label mb-1">Country Related
                    @if (getFieldInfo('countryRelated'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <select class="form-select" formControlName="countryRelated">
                    <option [value]="" selected>Select</option>
                    <option value="Yes" selected>Yes</option>
                    <option value="No" selected>No</option>
                  </select>
                </div>
              </div>
            }
            @if (!showStateCode && !taskAssignDialog && !disbursementTaskDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-1">
                  <label for="isStateRelated" class="form-label mb-1">State Related
                    @if (getFieldInfo('isStateRelated'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <select class="form-select" formControlName="isStateRelated">
                    <option [value]="" selected>Select</option>
                    <option value="Yes" selected>Yes</option>
                    <option value="No" selected>No</option>
                  </select>
                </div>
              </div>
            }
              @if (showCountry &&!taskAssignDialog) {
                <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                  <div class="mb-1">
                    <label class="form-label mb-1">Country
                      @if (getFieldInfo('country'); as info) {
                        @if (info.showInformation === 'Yes' && info.informationText) {
                          <info-tooltip [infoText]="info.informationText"></info-tooltip>
                        }
                      }
                      </label><span style="color:var(--al-danger);">*</span>
                      <select class="form-select" #countryName formControlName="country" >
                        <option value="" selected>Select</option>
                        @for (value of countries; track value) {
                          <option [ngValue]="value"
                            [selected]="value == taskForm.getRawValue().country">{{value}}
                          </option>
                        }
                      </select>
                      @if (submitted && country && country.invalid) {
                        <span style="color:var(--al-danger)">Country
                        is required</span>
                      }
                    </div>
                  </div>
                }
            @if (showStateCode && !taskAssignDialog) {
              <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
                <div class="mb-1">
                  <label class="form-label mb-1">State
                    @if (getFieldInfo('stateCode'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                    </label><span style="color:var(--al-danger);">*</span>
                    @if (taskForm.getRawValue().country === 'United States' && taskForm.getRawValue().countryRelated === 'Yes') {
                      <p-dropdown
                        class="form-select-wrapper"
                        formControlName="stateCode"
                        [options]="stateCodeMapList"
                        optionLabel="label"
                        optionValue="value"
                        [showClear]="true"
                        [filter]="true"
                        [style]="{'width':'100%'}"
                        placeholder="Select"
                        >
                      </p-dropdown>
                    }
                    @if (taskForm.getRawValue().country === 'Canada' && taskForm.getRawValue().countryRelated === 'Yes') {
                      <p-dropdown
                        class="form-select-wrapper"
                        formControlName="stateCode"
                        [options]="canadaStateList"
                        optionLabel="label"
                        optionValue="value"
                        [showClear]="true"
                        [filter]="true"
                        [style]="{'width':'100%'}"
                        placeholder="Select"
                        >
                      </p-dropdown>
                    }
                    @if (taskForm.getRawValue().country !== 'Canada' && taskForm.getRawValue().country !== 'United States' && taskForm.getRawValue().countryRelated === 'Yes') {
                      <input
                        class="form-control p-2"
                        type="text"
                        value="N/A"
                        readonly
                        >
                    }
                    @if (taskForm.getRawValue().countryRelated !== 'Yes') {
                      <p-dropdown
                        class="form-select-wrapper"
                        formControlName="stateCode"
                        [options]="stateCodeMapList"
                        optionLabel="label"
                        optionValue="value"
                        [showClear]="true"
                        [filter]="true"
                        [style]="{'width':'100%'}"
                        placeholder="Select"
                        >
                      </p-dropdown>
                    }
                    @if (submitted && stateCode && stateCode.invalid) {
                      <span style="color:var(--al-danger)">State is required</span>
                    }
                  </div>
                </div>
              }
          @if (!taskAssignDialog && !disbursementTaskDialog) {
            <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
              <div class="mb-1">
                <label for="quantityType" class="form-label mb-1">Quantity Type
                  @if (getFieldInfo('quantityType'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <select class="form-select" id="quantityType" readonly formControlName="quantityType">
                  <option [value]="" selected>Select</option>
                  <option value="State">State</option>
                  <option value="Number">Number</option>
                </select>
              </div>
            </div>
          }
          @if (showQuantityState && !taskAssignDialog && !disbursementTaskDialog) {
            <div class="col-12 col-md-6 col-xl-6 col-xxl-6">
              <div class="mb-1">
                <label for="quantityState" class="form-label mb-1">Quantity
                  @if (getFieldInfo('quantityState'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                @if (taskForm.getRawValue().quantityRelated=='Yes') {
                  <span style="color:var(--al-danger);">*</span>
                }
                @if (!taskForm.get('quantityState')?.disabled) {
                  <p-multiSelect [maxSelectedLabels]="10000"
                    appendTo="body"
                    defaultLabel="Select State"
                    formControlName="quantityState"
                    [options]="stateCodeMapList"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    [showToggleAll]="true"
                    filterPlaceHolder="Search states">
                  </p-multiSelect>
                }
                @if (taskForm.get('quantityState')?.disabled) {
                  <app-static-multi-value [values]="getSelectedStateLabelsList()"
                    [resetKey]="taskForm.get('id')?.value"></app-static-multi-value>
                }
                @if (submitted && quantityState && quantityState.invalid ) {
                  <span style="color:var(--al-danger)">Quantity
                  is required</span>
                }
              </div>
            </div>
          }
          @if (!showQuantityState && !taskAssignDialog && !disbursementTaskDialog) {
            <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
              <div class="mb-1">
                <label for="quantityNumber" class="form-label mb-1">Quantity
                  @if (getFieldInfo('quantityNumber'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                @if (taskForm.getRawValue().quantityRelated=='Yes') {
                  <span style="color:var(--al-danger);">*</span>
                }
                <input class="form-control p-2" type="number" formControlName="quantityNumber"
                  id="quantityNumber">
                @if (submitted && quantityNumber && quantityNumber.invalid ) {
                  <span style="color:var(--al-danger)">Quantity
                  is required</span>
                }
              </div>
            </div>
          }
          @if (!taskAssignDialog && (lpcdashboard || !onlytk) && !disbursementTaskDialog) {
            <div class="col-12 col-md-6 col-xl-4 col-xxl-3">
              <div class="mb-1">
                <label for="tkRating" class="form-label mb-1">TK Rating
                  @if (getFieldInfo('tkRating'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>@if (tkRatingMand) {
                <span style="color:var(--al-danger);">*</span>
              }
              <select class="form-select" id="tkRating" formControlName="tkRating">
                <option value="" selected>Select</option>
                <option value="1" >1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
            @if (tkRatingMand && tkRating && tkRating.invalid) {
              <span style="color:var(--al-danger)"
                >TK Rating is
              required</span>
            }
          </div>
        }
                </div>
              </p-accordionTab>
              }
            </p-accordion>

                <!-- <div *ngIf="!showProjectsView"> -->
                @if (!viewOnly && !taskAssignDialog && !taskDialog) {
                  <div class="row">
                    <div class="col-xl-12">
                      <div class="button-items" style="float: right;">
                        @if (manageDisbursementsBtn) {
                          <span appActionTooltip [pTooltip]="!manageDisbursementsEnabled ? getManageDisbursementsDisabledReason() : 'Manage Disbursement Tasks'" [actionDisabled]="!manageDisbursementsEnabled">
                            <button type="button" class="btn btn-info" [disabled]="!manageDisbursementsEnabled" (click)="manageDisbursements()"> Manage Disbursement Tasks </button>
                          </span>
                        }
                        @if (((userrole.includes('TK') && onlytk) || (userrole.includes('TK') && !onlytk && tkdashboard)) && disbursementTaskDialog && taskForm.getRawValue().statusCode.toUpperCase() == 'ACCEPTED') {
                          <span appActionTooltip [pTooltip]="!disPaymentCompletedEnabled ? getPaymentCompletedDisabledReason() : 'Mark payment as completed'" [actionDisabled]="!disPaymentCompletedEnabled">
                            <button type="button" class="btn btn-info" [disabled]="!disPaymentCompletedEnabled" (click)="readyToCompleteConfirmPopup()">
                              @if (!btnLoading) {
                                <span>
                                  Payment Completed
                                </span>
                              }
                              @if (btnLoading) {
                                <span>
                                  <i class="mdi mdi-loading mdi-spin"></i> Payment Completing...
                                </span>
                              }
                            </button>
                          </span>
                        }
                        <!-- <button class="btn btn-info " *ngIf="colsView.showForApproval"
                        (click)="forApproval(taskForm.getRawValue())" [disabled]="taskForm.getRawValue().disableForApproval"
                        [style.cursor]="taskForm.getRawValue().disableForApproval ? 'not-allowed' : 'pointer'"
                        [style.pointer-events]="'auto'"
                        title="{{taskForm.getRawValue().disableForApproval ? taskForm.getRawValue().disableForApprovalTitle : 'For Approval'}}">
                        Approve <i class="mdi mdi-check-circle"></i>
                      </button> -->
                    </div>
                  </div>
                </div>
              }

          </div>

            <aside class="tw-rail" [class.tw-rail-hidden]="notesRailCollapsed"
              [attr.aria-hidden]="notesRailCollapsed">
              <div class="tw-rail-body">
                <div class="tw-rail-block">
                  <div class="tw-rail-heading">
                    Task Notes
                    <span class="tw-rail-chip">TASK-LEVEL</span>
                    <span class="tw-rail-role">{{ (onlytk && !lpcdashboard) ? 'Read-only for TK' : 'Editable · saves with Update' }}</span>
                  </div>
        <div class="col-12">
          <div class="mb-1">
            <label for="notes" class="form-label mb-1">Task Notes
              @if (getFieldInfo('notes'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <textarea placeholder="" class="form-control" formControlName="notes" appSpellCheck rows="6"
              [readonly]="onlytk && !lpcdashboard"></textarea>
          </div>
        </div>
                </div>
                @if (taskForm.get('id')?.value && !taskAssignDialog) {
                  <div class="tw-rail-block tw-rail-comments">
                    <div class="tw-rail-heading">Comments</div>
                    <app-comments
                      [targetType]="'Task'"
                      [targetId]="taskForm.get('id')?.value"
                      [taskInfo]="{
                          projectName: taskForm.get('projectName')?.value,
                          taskName: taskForm.get('taskName')?.value,
                          taskId: taskForm.get('id')?.value
                      }">
                    </app-comments>
                  </div>
                }
              </div>
            </aside>

        </div>
      </div>
    }
      @if (manageDisbursementsDialog) {
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3">
                <div class="mb-3">
                  <label class="form-label">Disbursement Tasks <span style="color:var(--al-danger);">*</span></label>
                  <p-multiSelect [maxSelectedLabels]="10000"
                    [options]="allDbDisbursements"
                    formControlName="newDisbursementTaskIds"
                    [filter]="true"
                    [showToggleAll]="true"
                    [optionLabel]="'taskName'"
                    [optionValue]="'id'"
                    placeholder="Select"
                    [appendTo]="'body'"
                    [emptyFilterMessage]="'No data found'"
                    [emptyMessage]="'No data found'"
                  ></p-multiSelect>
                </div>
              </div>
              <div class="col-xl-3">
                <div style="margin-top: 9%;">
                  <button class="btn btn-primary" pTooltip="Add disbursement task" appActionTooltip (click)="addDisbursement()">
                    <i class="mdi mdi-plus"></i> Add Disbursement Task
                  </button>
                </div>
              </div>
            </div>
            <p-table #dtDisbursement [(value)]="disbursements" dataKey="id" styleClass="p-datatable-disbursement"
              responsiveLayout="scroll" rows="5" [rowHover]="true" >
              <ng-template pTemplate="header">
                <tr>
                  <th>Task Name</th>
                  <th>Task Full Name</th>
                  <th>Task Type</th>
                  <th>Practice Area</th>
                  <th>Status</th>
                  <th style="width:6rem">Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-disbursement let-columns="columns">
                <tr>
                  <td>{{disbursement.taskName}}</td>
                  <td>{{disbursement.taskFullName}}</td>
                  <td>{{disbursement.taskTypeCode}}</td>
                  <td>{{disbursement.practiceAreaCode}}</td>
                  <td>{{disbursement.statusCode}}</td>
                  <td class="text-center">
                    <span appActionTooltip [pTooltip]="(disbursement.datePaid || disbursement.disbursementAmount || disbursement.isCompleted?.toUpperCase() === 'YES') ? getDeleteDisbursementDisabledReason(disbursement) : 'Delete disbursement task'" [actionDisabled]="disbursement.datePaid || disbursement.disbursementAmount || disbursement.isCompleted?.toUpperCase() === 'YES'">
                      <button class="btn btn-danger btn-sm" [disabled]="disbursement.datePaid||disbursement.disbursementAmount ||disbursement.isCompleted?.toUpperCase() === 'YES'" (click)="deleteDisbursement(disbursement.id)">
                        Delete
                      </button>
                    </span>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr >
                  <td colspan="9" class="text-center">No Records Found</td>
                </tr>
              </ng-template>
            </p-table>
            <div class="row mt-3">
              <div class="col-xl-12 d-flex justify-content-end">
                <div class="button-items" style="gap: 10px;">
                  <button class="btn btn-secondary" pTooltip="Back" appActionTooltip (click)="BackToeditTask()">
                    <i class="mdi mdi-arrow-left"></i> Back
                  </button>
                  <button class="btn btn-primary" pTooltip="Update disbursements" appActionTooltip (click)="saveDisbursements()">
                    <i class="mdi mdi-content-save"></i> Update Disbursements
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </form>
  </ng-template>

  <p-dialog  [resizable]="false" [draggable]="false" [(visible)]="taskDialog" (onHide)="closeDialog()"
    [style]="{'width': 'min(1536px, 96%)', 'max-height':'calc(100vh - 40px)'}" [modal]="true" [styleClass]="'p-fluid tw-dialog' + (taskAssignDialog ? ' tw-dialog-assign' : '')" [closable]="false">
    <ng-template pTemplate="header">
      <div class="tw-dialog-header">
        <ng-container *ngTemplateOutlet="taskRecordIdentity"></ng-container>
        <div class="tw-record-actions tw-dialog-actions">
          @if (!viewOnly && !taskAssignDialog && manageDisbursementsBtn) {
            <span appActionTooltip [pTooltip]="!manageDisbursementsEnabled ? getManageDisbursementsDisabledReason() : 'Manage Disbursement Tasks'" [actionDisabled]="!manageDisbursementsEnabled">
              <button type="button" class="tw-hdr-btn" [disabled]="!manageDisbursementsEnabled" (click)="manageDisbursements()">Manage Disbursement Tasks</button>
            </span>
          }
          @if (!viewOnly && !taskAssignDialog && ((userrole.includes('TK') && onlytk) || (userrole.includes('TK') && !onlytk && tkdashboard)) && disbursementTaskDialog && taskForm.getRawValue().statusCode.toUpperCase() == 'ACCEPTED') {
            <span appActionTooltip [pTooltip]="!disPaymentCompletedEnabled ? getPaymentCompletedDisabledReason() : 'Mark payment as completed'" [actionDisabled]="!disPaymentCompletedEnabled">
              <button type="button" class="tw-hdr-btn" [disabled]="!disPaymentCompletedEnabled" (click)="readyToCompleteConfirmPopup()">
                @if (!btnLoading) { <span>Payment Completed</span> }
                @if (btnLoading) { <span><i class="mdi mdi-loading mdi-spin"></i> Payment Completing...</span> }
              </button>
            </span>
          }
          @if (viewOnly && !taskAssignDialog) {
            @if (canAcceptCurrentDisbursementTask()) {
              <button type="button" class="tw-hdr-btn tw-hdr-btn-primary" pTooltip="Accept this task"
                appActionTooltip (click)="openCurrentTaskAcceptance()">
                <i class="mdi mdi-check"></i> Accept Task
              </button>
            }
            <span appActionTooltip [actionTooltipDelay]="0" [pTooltip]="isEditBlocked() ? getEditTaskDisabledReason() : 'Edit this task'" [actionDisabled]="isEditBlocked()">
              <button type="button" class="tw-hdr-btn tw-hdr-btn-primary" [disabled]="isEditBlocked()" (click)="switchToEditMode()">
                <i class="mdi mdi-pencil"></i> Edit Task
              </button>
            </span>
          }
          @if (!taskAssignDialog) {
            <button type="button" class="tw-hdr-btn" (click)="notesRailCollapsed = !notesRailCollapsed"
              [pTooltip]="notesRailCollapsed ? 'Show notes and comments' : 'Hide notes and comments'" appActionTooltip>
              <i class="mdi" [ngClass]="notesRailCollapsed ? 'mdi-page-layout-sidebar-right' : 'mdi-page-layout-sidebar-left'"></i>
              {{ notesRailCollapsed ? 'Show notes' : 'Hide notes' }}
            </button>
          }
          @if (!viewOnly && !taskAssignDialog) {
            <button type="button" class="tw-hdr-btn tw-hdr-btn-primary" pTooltip="Update task" appActionTooltip (click)="saveTask()">
              Update Task
              @if (btnLoading) { <i class="fa fa-solid fa-sync fa-spin ms-1"></i> }
            </button>
          }
          <button type="button" class="tw-dialog-close" (click)="requestCloseTaskDialog()"
            pTooltip="Close" appActionTooltip aria-label="Close task">
            <i class="mdi mdi-window-close"></i>
          </button>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <app-notification [errorMsg]="errorMsg"></app-notification>

      <div class="card task-details"
        id="assignmentTaskContextCard"
        [hidden]="taskAssignDialog && !assignmentDetailsExpanded"
        [class.tw-task-details-assign]="taskAssignDialog"
        [class.tw-task-details-expanded]="taskAssignDialog && assignmentDetailsExpanded">
        <ng-container *ngTemplateOutlet="taskEditTemplate"></ng-container>
      </div>
      @if (taskAssignDialog && !viewTaskAssignmentDialog) {
        <div class="tw-assign" [class.tw-assign-no-users]="!loadingTkUsers && !filteredTkUsers.length">
          <div class="tw-assign-cols">
            <div class="tw-assign-col tw-assign-col-pick">
                <div class="tw-assign-controls">
                <div class="tw-assign-control-bundle tw-assign-bundle-current">
                  <span class="tw-assign-current-label">Currently assigned to
                    @if (getFieldInfo('assignedTkUser'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </span>
                  @if (assignedTkUser?.[0]?.timekeeper; as currentTk) {
                    <span class="tw-assign-current-name">{{ currentTk.firstName }} {{ currentTk.lastName }}</span>
                    <span class="tw-assign-current-email">{{ assignedTkUserName }}</span>
                  } @else {
                    <span class="tw-assign-current-name">{{ assignedTkUserName || openTask?.projTaskAssignmentUsername || 'Unassigned' }}</span>
                  }
                </div>
                <div class="tw-assign-control-bundle tw-assign-bundle-pick">
                  <div class="tw-assign-pickhead">
                    <label class="form-label mb-0">{{ enableReassignTask ? 'Reassign task to' : 'Assign task to' }} <span style="color:var(--al-danger);">*</span></label>
                    <span class="tw-assign-count">{{ filteredTkUsers.length }} available</span>
                  </div>
                  <input type="text" class="form-control p-2 tw-assign-search" [(ngModel)]="tkSearchTerm" (ngModelChange)="applyTkFilter()"
                    [ngModelOptions]="{standalone: true}" placeholder="Search by name or email">
                </div>
                @if (enableReassignTask) {
                  <div class="tw-assign-control-bundle tw-assign-bundle-reason">
                    <label for="reassignReason">Reassign Reason<span style="color:var(--al-danger);">*</span></label>
                    <select #reassignReason id="reassignReason" class="form-select form-select-sm"
                      (change)="onReassignReasonChange(reassignReason.value)">
                      <option selected value="">Select Reassign Reason</option>
                      @for (reason of reassignReasonList; track reason) {
                      <option [value]="reason.value">{{reason.label}}</option>
                    }
                    </select>
                  </div>
                }
                  <div class="tw-assign-control-bundle tw-assign-bundle-options">
                    <div class="form-check mb-0">
                      <input class="form-check-input" id="isIncludeTodayPick" type="checkbox" [(checked)]="includeToday"
                        [disabled]="viewTaskAssignmentDialog || loadingTkUsers"
                        (change)="includeTodayAssignment(taskForm.getRawValue().id,$event)">
                      <label class="form-check-label" for="isIncludeTodayPick">
                        Include Today
                        @if (getFieldInfo('isIncludeToday'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                      </label>
                    </div>
                    @if (enableReassignTask) {
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="checkbox" id="deleteTr" [(ngModel)]="deleteTRAR"
                        [ngModelOptions]="{standalone: true}" [disabled]="viewTaskAssignmentDialog">
                      <label class="form-check-label" for="deleteTr">Delete Time Records</label>
                    </div>
                    @if (deleteTRAR) {
                      <div class="tw-assign-warn">Time already logged will be rejected and removed.</div>
                    }
                    }
                  </div>
              </div>
              <div class="tw-assign-table">
                <div class="tw-assign-head">
                  <span>TK User</span>
                  <span>Type</span>
                  <span>Total Available Time</span>
                  <span>Must Accept Within <span style="color:var(--al-danger);">*</span></span>
                  <span>{{ enableReassignTask ? 'Re-Assign' : 'Assign' }}</span>
                </div>
                @if (loadingTkUsers) {
                  <div class="tw-assign-empty">Loading available timekeepers&hellip;</div>
                } @else if (!filteredTkUsers.length) {
                  <div class="tw-assign-empty">
                    @if (tkSearchTerm) {
                      No timekeepers match &ldquo;{{ tkSearchTerm }}&rdquo;.
                    } @else {
                      No TK Users found. Timekeepers appear here once they have availability recorded for this task&rsquo;s dates.
                    }
                  </div>
                } @else {
                  <ul class="tw-assign-list">
                    @for (u of filteredTkUsers; track $index) {
                      <li class="tw-assign-row">
                        <span class="tw-assign-who">
                          <span class="tw-assign-name">{{ u.tkFirstName }} {{ u.tklastName }}</span>
                          <span class="tw-assign-mail">{{ u.tkEmailId }}</span>
                        </span>
                        <span class="tw-assign-type">{{ u.userType }}</span>
                        <span class="tw-assign-time">
                          <span class="tw-assign-hrs">{{ u.totalAvailableTimeStr }}</span>
                          <span class="tw-assign-cap">available</span>
                        </span>
                        <span class="tw-assign-accept">
                          <select class="form-select form-select-sm" [(ngModel)]="u['mustAcceptTime']"
                            [ngModelOptions]="{standalone: true}">
                            <option [value]="0">Must Accept Within</option>
                            @for (time of u['mustAcceptList']; track time) {
                              <option [value]="time.value">{{time.label}}</option>
                            }
                          </select>
                        </span>
                        <span class="tw-assign-go">
                          @if (!enableReassignTask) {
                            <button type="button" class="btn btn-primary btn-sm tw-assign-action" [disabled]="!u.mustAcceptTime" (click)="saveAssignment(u)"
                              pTooltip="Assign to this TK user" appActionTooltip><i class="mdi mdi-account-check"></i> Assign</button>
                          } @else {
                            <span appActionTooltip [pTooltip]="disableReassignbtnFlag ? getReassignDisabledReason() : 'Reassign Task'" [actionDisabled]="disableReassignbtnFlag">
                              <button class="btn btn-primary btn-sm tw-assign-action" [disabled]="disableReassignbtnFlag || !u.mustAcceptTime"
                                (click)="saveReAssignment(u)"><i class="mdi mdi-account-switch"></i> Reassign</button>
                            </span>
                          }
                          @if (u.loading) { <i class="fa fa-solid fa-sync fa-spin ms-1"></i> }
                        </span>
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>

          </div>
        </div>
      }
  @if (viewTaskAssignmentDialog) {
    <div class="tw-assign tw-assign-history">
      <div class="tw-history-table">
        <div class="tw-history-head">
          <span>TK User Name</span>
          <span>TK User Email</span>
          <span>TK User Type</span>
          <span>Date</span>
          <span>TK Accepted Time</span>
          <span>Status</span>
        </div>
        @if (loadingTkUsers) {
          <div class="tw-history-empty">Loading assignment history&hellip;</div>
        } @else if (!taskAssignedUsers?.length) {
          <div class="tw-history-empty">No Records found</div>
        } @else {
          <ul class="tw-history-list">
            @for (tkUser of taskAssignedUsers; track $index) {
              <li class="tw-history-row">
                <span data-label="TK User Name">{{tkUser["timekeeper"].firstName}} {{tkUser["timekeeper"].lastName}}</span>
                <span data-label="TK User Email">{{tkUser["timekeeper"].mainEmail}}</span>
                <span data-label="TK User Type">{{tkUser["timekeeper"].userTypeCode}}</span>
                <span data-label="Date">{{tkUser["modifiedDate"]}}</span>
                <span data-label="TK Accepted Time">{{tkUser["tkAcceptedTime"]}}</span>
                <span data-label="Status">{{tkUser["assignmentStatus"]}}</span>
              </li>
            }
          </ul>
        }
      </div>
      @if (enableDeleteTask) {
        <div class="tw-history-delete">
          <span appActionTooltip [pTooltip]="disableDelbtnFlag ? getDeleteAssignmentDisabledReason() : 'Delete task'" [actionDisabled]="disableDelbtnFlag">
            <button type="button" class="btn btn-danger" [disabled]="disableDelbtnFlag" (click)="deleteTask(taskForm.getRawValue())">Delete
              @if (loadingData) {
                <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
              }</button>
          </span>
          <select #deleteReason class="form-select form-select-sm" (change)="onDeleteReasonChange(deleteReason.value)">
            <option selected [value]="">Select Delete Task Reason</option>
            @for (reason of deleteReasonList; track reason) {
              <option [value]="reason.value">
                {{reason.label}}
              </option>
            }
          </select>
          <div class="form-check mb-0">
            <input class="form-check-input" id="rejecttr" type="checkbox" [(ngModel)]="rejectTimeRecords">
            <label class="form-check-label" for="rejecttr">Delete Time Records</label>
          </div>
        </div>
      }
    </div>
  }

  </ng-template>
</p-dialog>


<p-dialog [(visible)]="newTaskDialog" [resizable]="false" [draggable]="false" (onHide)="closeNewTaskDialog()"
  [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">

  <ng-template pTemplate="content">
    <div class="card">
      <div class="card-body">
        <div class="row" style="margin-bottom:2%;">
          <div class="col-sm-4">
            <label for="assignProject" class="form-label mb-1">All Projects:</label>
            <select id="assignProject" class="form-select" [(ngModel)]="selectedProject"
              (ngModelChange)="projectChange($event)">
              <option [selected]="true" [value]="">Select</option>
              @for (project of allProjects; track project) {
                <option [ngValue]="project"
                  [selected]="project.id==selectedProject.id">
                  {{project.organizationName+":"+project.name}}
                </option>
              }
            </select>
          </div>
          <div class="col-sm-4">
            <label for="assignTask" class="form-label mb-1">Task:</label>
            <!-- <p-multiSelect [maxSelectedLabels]="10000"  defaultLabel="Select Tasks"  [options]="AllTasks" optionLabel="key" optionValue="value"></p-multiSelect> -->

            <select id="assignTask" class="form-select" [(ngModel)]="newTask">
              <option [selected]="true" [ngValue]="">Select</option>
              @for (value of AllTasks; track value) {
                <option [ngValue]="value">{{value.taskName}}
                </option>
              }
            </select>
          </div>

          <div class="col-sm-4">
            <button class="btn btn-primary btn-sm" (click)="addTemplateTask()" pTooltip="Assign task" appActionTooltip
            style="margin-top: 7%;">Assign Task</button>
            @if (assignLoading) {
              <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
            }
          </div>
        </div>
        <p-table [columns]="projectTaskCols" [(value)]="projectAssignedTasks" dataKey="id"
          styleClass="p-datatable-tasks" responsiveLayout="scroll" rows="5" [rowHover]="true"
          [loading]="loading" responsiveLayout="scroll">

          <ng-template pTemplate="header">
            <tr>
              <th>Task Name</th>
              <th>Task Type</th>
              <th>Description</th>
              <th style="width:6rem">Delete</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-tasks let-columns="columns">
            <tr>
              @for (col of columns; track col) {
                <td>
                  {{tasks[col.field]}}
                </td>
              }
              <td>
                <div class="flex justify-content-between align-items-center">
                  <a class="btn btn-warning btn-sm" (click)="deleteTask(tasks)" role="button" pTooltip="Delete task" appActionTooltip><i
                  class="mdi mdi-trash-can" width="44" height="44"></i></a>
                </div>
              </td>
            </tr>

          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                No records found
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="acceptTaskDialog" [resizable]="false" [draggable]="false" (onHide)="closeAcceptTaskDialog()"
  [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-notification [errorMsg]="errorMsg"></app-notification>

    <form [formGroup]="taskForm">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-4">
              <div class="mb-1">
                <label for="taskName" class="form-label mb-1">Task Name
                  @if (getFieldInfo('taskName'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="taskName"
                  id="taskName">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-1">
                <label for="projectName" class="form-label mb-1">Project Name
                  @if (getFieldInfo('projectName'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="projectName"
                  id="projectName">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-1">
                <label for="estimatehours" class="form-label mb-1">Estimated Time(HH:MM)
                  @if (getFieldInfo('timeEstimate'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <!-- <input class="form-control p-2" type="text" [(ngModel)]="estimatehours" [ngModelOptions]="{standalone: true}" readonly id="estimatehours"> -->
                <p-calendar appendTo="body" [showTime]="true"  hourFormat="24"
                  [timeOnly]="true" formControlName="timeEstimate"
                  [defaultDate]="defaultTime" [style]="{'width':'100%'}">
                </p-calendar>
              </div>
            </div>
            @if (lpcdashboard || !onlytk) {
              <div class="col-xl-4" style="width:13%">
                <div class="mb-1">
                  <label for="maxTime" class="form-label mb-1">Max Time(HH:MM)
                    @if (getFieldInfo('maxTime'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24"
                    [timeOnly]="true" formControlName="maxTime" [defaultDate]="defaultTime">
                  </p-calendar>
                </div>
              </div>
            }
            <div class="col-xl-4"  [ngStyle]="{'width':lpcdashboard || !onlytk?'20%':'33%'} ">
              <div class="mb-1">
                <label for="isRequireEstimate" class="form-label mb-1">Required Estimate
                  @if (getFieldInfo('isRequireEstimate'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="isRequireEstimate"
                  id="isRequireEstimate">
              </div>
            </div>
            <div class="col-xl-2">
              <div class="mb-1">
                <label for="taskDueDate" class="form-label mb-1">Due Date
                  @if (getFieldInfo('taskDueDate'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="datetime" formControlName="taskDueDate"
                  id="taskDueDate">
              </div>
            </div>
            <div class="col-xl-2">
              <div class="mb-1">
                <label for="dueDaySlot" class="form-label mb-1">Due Date Slot
                  @if (getFieldInfo('dueDaySlot'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="dueDaySlot"
                  id="dueDaySlot">
              </div>
            </div>
            <!-- <div class="col-xl-4">
            <div class="mb-1">
              <label for="assignedTime" class="form-label mb-1">Assigned Time</label>
              <input class="form-control p-2" type="text" [(ngModel)]="assignedTime" [ngModelOptions]="{standalone: true}" readonly id="estimatehours">
            </div>
          </div> -->
          <!-- <div class="col-xl-3" >
          <div class="form-check mb-1">
            <input class="form-check-input" type="checkbox" id="isIncludeToday"
              disabled>
            <label class="form-check-label" for="isIncludeToday">
              Include Today
            </label>
          </div>
        </div> -->
        <div class="col-xl-4">
          <div class="mb-1">
            <label for="stateDesc" class="form-label mb-1">State
              @if (getFieldInfo('stateDesc'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <input class="form-control p-2" type="text" formControlName="stateDesc"
              id="stateDesc">
          </div>
        </div>
        <div class="col-xl-4">
          <div class="mb-1">
            <label for="notes" class="form-label mb-1">Notes
              @if (getFieldInfo('notes'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <textarea placeholder="" class="form-control" formControlName="notes" appSpellCheck></textarea>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="mb-1">
            <label for="description" class="form-label mb-1">Description
              @if (getFieldInfo('description'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <textarea placeholder="" class="form-control" formControlName="description" appSpellCheck></textarea>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="form-check mb-1">
            <input class="form-check-input" id="isIncludeToday" type="checkbox"
              [(checked)]="acceptDdata.includeToday" readonly>
            <label class="form-check-label" for="isIncludeToday">
              Include Today
              @if (getFieldInfo('isIncludeToday'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

@if (acceptDdata.taskTypeCode?.toUpperCase()=='DISBURSEMENTS') {
  <div class="alert alert-warning d-flex align-items-center" style="background: color-mix(in oklab, var(--al-warning) 16%, var(--al-surface)); border: 1px solid color-mix(in oklab, var(--al-warning) 45%, var(--al-surface)); border-radius: 4px; padding: 12px; margin-top: 10px;">
    <i class="mdi mdi-alert-circle-outline" style="font-size: 1.5rem; color: var(--al-warning); margin-right: 10px;"></i>
    <div>
      <strong>Note:</strong>
      <span style="color: var(--al-warning);">
        Time entry is <b>not allowed</b> for Disbursement Tasks.
        Please use <b>Accept</b> or <b>Reject</b> only.
      </span>
    </div>
  </div>
}

@if (acceptDdata.statusCode=='Assigned' && (onlytk || tkdashboard)) {
  <div class="row">
    <p-table [(value)]="daywiseData" dataKey="id" [scrollable]="true" scrollDirection="both"
      scrollHeight="100px" styleClass="p-datatable-daywiseData" responsiveLayout="scroll" rows="5"
      [rowHover]="true" class="insidetable" [loading]="loadingDayWiseData" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th>Date</th>
          <th>Total Time Available(HH:MM)</th>
          <th>Select Time(HH:MM) <span style="color:var(--al-danger);">*</span></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-day let-columns="columns">
        <tr>
          <td style="padding:0px 0 px">
            {{day["availableDate"]}}
          </td>
          <td style="padding:0px 0 px">
            {{day["availableTime"]}}
          </td>
          <td style="padding:0rem 0rem">
            <div>
              <p-calendar appendTo="body" [showTime]="true" hourFormat="24" [timeOnly]="true" [maxDate]="day['maxAcceptTime']"
              [(ngModel)]="day['minutes']" [defaultDate]="defaultTime" [disabled]="acceptDdata.taskTypeCode?.toUpperCase()=='DISBURSEMENTS'"></p-calendar>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="4" style="padding: 1rem !important;">
            No records found
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- <div class="flex justify-content-center align-items-center">
    <a class="btn btn-danger btn-sm button" (click)="reject()" role="button">Reject</a>
    <a class="btn btn-success btn-sm button" (click)="accept()" [disabled]="acceptDdata[statusCode]!='OPEN'" role="button">Accept</a>
  </div>                -->
</div>
}

@if (acceptDdata.statusCode!='Assigned'&& (onlytk || tkdashboard)) {
  <div class="row">
    <p-table [(value)]="accepteddaywiseData" dataKey="id" [scrollable]="true" scrollDirection="both"
      scrollHeight="100px" styleClass="p-datatable-daywiseData" responsiveLayout="scroll" rows="5"
      [rowHover]="true" class="insidetable" [loading]="loadingDayWiseData" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          @if (lpcflag) {
            <th></th>
          }
          <th>Date</th>
          <th>TK Mail</th>
          <th>Time Accepted(HH:MM)</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-day let-columns="columns">
        <tr>
          @if (lpcflag) {
            <td><input type="checkbox"></td>
          }
          <td style="padding:0px 0 px">
            {{day["date"]}}
          </td>
          <td style="padding:0px 0 px">
            {{day["tkMail"]}}
          </td>
          <td style="padding:0px 0 px">
            <p-calendar readonly appendTo="body" [showTime]="true" hourFormat="24" [timeOnly]="true"
            [(ngModel)]="day['minutes']" [defaultDate]="defaultTime"></p-calendar>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="4" style="padding: 1rem !important;">
            No Assignments Found to Accept/Reject for the Task.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
@if (lpcdashboard || onlylpcadmin) {
  <div class="row">
    <p-table [(value)]="accepteddaywiseData" dataKey="id" [scrollable]="true" scrollDirection="both"
      scrollHeight="100px" styleClass="p-datatable-daywiseData" responsiveLayout="scroll" rows="5"
      [rowHover]="true" class="insidetable" [loading]="loadingDayWiseData" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>Date</th>
          <th>Status</th>
          <th>TK Mail</th>
          <th>Time Accepted/Assigned(HH:MM)</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-day let-columns="columns">
        <tr>
          <td><input type="checkbox" (change)="forApprovalChange($event,day)"></td>
          <td style="padding:0px 0 px">
            {{day["date"]}}
          </td>
          <td style="padding:0px 0 px">
            {{day["status"]}}
          </td>
          <td style="padding:0px 0 px">
            {{day["tkMail"]}}
          </td>
          <td style="padding:0px 0 px">
            <p-calendar readonly appendTo="body" [showTime]="true" hourFormat="24" [timeOnly]="true"
            [(ngModel)]="day['minutes']" [defaultDate]="defaultTime"></p-calendar>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="4" style="padding: 1rem !important;">
            No Assignments Found to Accept/Reject for the Task.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
<div class="row">
  <div class="col-xl-12">
    <div class="button-items" style="float: right;padding:10px;">
      @if (onlytk || tkdashboard) {
        <span appActionTooltip [pTooltip]="!accbtnflag ? getAcceptDisabledReason() : 'Accept task'" [actionDisabled]="!accbtnflag">
          <button class="btn btn-success" [disabled]="!accbtnflag"
            (click)="accept()">Accept@if (accbtnLoading) {
            <i
            style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
          }</button>
        </span>
      }
      <span appActionTooltip [pTooltip]="!rejbtnflag ? getRejectDisabledReason() : 'Reject task'" [actionDisabled]="!rejbtnflag">
        <button class="btn btn-danger" [disabled]="!rejbtnflag" (click)="reject()">Reject@if (rejbtnLoading) {
          <i
          style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
        }</button>
      </span>
    </div>
  </div>
</div>
</ng-template>

</p-dialog>
<p-dialog [(visible)]="addTRDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
  [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">

    <app-notification [errorMsg]="errorMsg"></app-notification>
    @if (cardLoading) {
      <div class="loader">
        <div class="spinner"></div>
      </div>
    }
    <form [formGroup]="taskForm">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-4">
              <div class="mb-1">
                <label for="taskName" class="form-label mb-1">Task Name
                  @if (getFieldInfo('taskName'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="taskName"
                  id="taskName">

              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-1">
                <label for="orgName" class="form-label mb-1">Organization Name
                  @if (getFieldInfo('orgName'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="orgName"
                  id="orgName">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-1">
                <label for="matterName" class="form-label mb-1">Matter Name
                  @if (getFieldInfo('matterName'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="matterName"
                  id="matterName">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-1">
                <label for="projectName" class="form-label mb-1">Project Name
                  @if (getFieldInfo('projectName'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control p-2" type="text" formControlName="projectName"
                  id="projectName">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-1">
                <label for="estimatehours" class="form-label mb-1">Estimated Time(HH:MM)
                  @if (getFieldInfo('timeEstimate'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <!-- <input class="form-control p-2" type="text" [(ngModel)]="estimatehours" [ngModelOptions]="{standalone: true}" readonly id="estimatehours"> -->
                <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24"
                  [timeOnly]="true" formControlName="timeEstimate"
                  [defaultDate]="defaultTime">
                </p-calendar>
              </div>
            </div>
            <!-- <div class="col-xl-4" style="width:13%">
            <div class="mb-1">
              <label for="maxTime" class="form-label mb-1">Max Time</label>
              <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24"
                [timeOnly]="true" formControlName="maxTime" [defaultDate]="defaultTime">
              </p-calendar>
            </div>
          </div> -->
          <div class="col-xl-4">
            <div class="mb-1">
              <label for="isRequireEstimate" class="form-label mb-1">Required Estimate
                @if (getFieldInfo('isRequireEstimate'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" formControlName="isRequireEstimate"
                id="isRequireEstimate">
            </div>
          </div>
          <div class="col-xl-3">
            <div class="mb-1">
              <label for="taskDueDate" class="form-label mb-1">Due Date
                @if (getFieldInfo('taskDueDate'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="datetime" formControlName="taskDueDate"
                id="taskDueDate">
            </div>
          </div>
          <div class="col-xl-3">
            <div class="mb-1">
              <label for="stateDesc" class="form-label mb-1">State
                @if (getFieldInfo('stateDesc'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" formControlName="stateDesc"
                id="stateDesc">
            </div>
          </div>
          <div class="col-xl-3">
            <div class="mb-1">
              <label for="dueDaySlot" class="form-label mb-1">Due Date Slot
                @if (getFieldInfo('dueDaySlot'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" formControlName="dueDaySlot"
                id="dueDaySlot">
            </div>
          </div>
          <div class="col-xl-3">
            <div class="mb-1">
              <label for="inserted Time" class="form-label mb-1">Logged Time(HH:MM)
                @if (getFieldInfo('timeRecordsLoggedTime'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <!-- <input class="form-control p-2" type="text" formControlName="timeRecordsLoggedTime" -->
              <!-- id="timeRecordsLoggedTime"> -->
              <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24"
                [timeOnly]="true" formControlName="timeRecordsLoggedTime"
                [defaultDate]="defaultTime">
              </p-calendar>
            </div>
          </div>
          <div class="col-xl-12">
            <div class="d-flex align-items-center justify-content-between">
              <!-- Left side: Checkboxes -->
              <div class="d-flex gap-4">
                <div class="form-check mb-1">
                  <input class="form-check-input" type="checkbox" id="isIncludeToday"
                    [(checked)]="acceptDdata.includeToday" readonly>
                  <label class="form-check-label" for="isIncludeToday">
                    Include Today
                    @if (getFieldInfo('isIncludeToday'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                </div>

                <div class="form-check mb-1">
                  <input class="form-check-input" type="checkbox" id="taskReadyToComplete" formControlName="taskReadyToComplete"
                    [disabled]="isEntityRelatedTask && !isEntityInfoComplete()">
                  <label class="form-check-label" for="taskReadyToComplete">
                    Ready to Complete
                    @if (getFieldInfo('taskReadyToComplete'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                    @if (isEntityRelatedTask && !isEntityInfoComplete()) {
                      <span class="text-danger ms-1" style="font-size: 0.85em;">
                        (Update entity info first)
                      </span>
                    }
                  </label>
                </div>
              </div>

              <!-- Right side: Buttons -->
              <div class="d-flex gap-2">
                <!-- Update/Show Entity Information Button - Only show when entityRelated is 'Yes' -->
                @if (isEntityRelatedTask) {
                  <span appActionTooltip [pTooltip]="(!currentTaskEntity || isLoadingEntity) ? getEntityInfoDisabledReason() : (isEntityInfoComplete() ? 'Show entity information' : 'Update entity information')" [actionDisabled]="!currentTaskEntity || isLoadingEntity">
                    <button class="btn btn-sm"
                                          [ngClass]="{
                                              'btn-secondary': !currentTaskEntity || isLoadingEntity,
                                              'btn-warning': currentTaskEntity && !isEntityInfoComplete() && !isLoadingEntity,
                                              'btn-success': currentTaskEntity && isEntityInfoComplete() && !isLoadingEntity
                                          }"
                      (click)="openUpdateEntityDialog()"
                      [disabled]="!currentTaskEntity || isLoadingEntity">
                      @if (!currentTaskEntity || isLoadingEntity) {
                        <i class="pi pi-spin pi-spinner"></i>
                      }
                      @if (currentTaskEntity && !isEntityInfoComplete() && !isLoadingEntity) {
                        <i class="mdi mdi-information-outline"></i>
                      }
                      @if (currentTaskEntity && isEntityInfoComplete() && !isLoadingEntity) {
                        <i class="mdi mdi-eye"></i>
                      }
                      @if (!currentTaskEntity || isLoadingEntity) {
                        <span>Loading...</span>
                      }
                      @if (currentTaskEntity && !isLoadingEntity) {
                        <span>{{ isEntityInfoComplete() ? 'Show Entity Information' : 'Update Entity Information' }}</span>
                      }
                      @if (currentTaskEntity && !isEntityInfoComplete() && !isLoadingEntity) {
                        <span class="badge badge-light ms-1">Incomplete</span>
                      }
                    </button>
                  </span>
                }

                <span appActionTooltip [pTooltip]="disableADDTR ? getAddTRDisabledReason() : 'Add time record'" [actionDisabled]="disableADDTR">
                  <button class="btn btn-primary btn-sm" [disabled]="disableADDTR"
                  (click)="addTimeRecord(taskForm.getRawValue())">Add Time Record</button>
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
  <p-table [(value)]="timeRecords" dataKey="id" [scrollable]="true" scrollDirection="both"
    scrollHeight="240px" styleClass="p-datatable-daywiseData" responsiveLayout="scroll" rows="5"
    [rowHover]="true" class="insidetable" [loading]="loadingData" responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th>Time Record Date<span style="color:var(--al-danger);">*</span></th>
        <th>Time Record Description<span style="color:var(--al-danger);">*</span></th>
        <th>Time Record Comments</th>
        <th>Time Spent(HH:MM)<span style="color:var(--al-danger);">*</span></th>
        <th>Quantity</th>
        <th>Time Record Status</th>
        <th>Delete</th>

      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record let-rowIndex="rowIndex" let-columns="columns">
      <tr>
        <td>
          <p-calendar appendTo="body" [(ngModel)]="record.date" (ngModelChange)="checkDuplicateTR()" [minDate]="today" [minDate]="timeRecordsStartDate" [maxDate]="timeRecordsDueDate" [disabled]="record.disableInp">
          </p-calendar>
          <!-- "dueDate < today ? dueDate : today" -->
          <!-- <select id="date" class="form-select" name="selectOptions"  [(ngModel)]="record.date">
          <option *ngFor="let date of acceptedDates" [value]="date" [selected]="date === record.date">{{ date }}</option>
        </select> -->

        @if (!record.dateValid) {
          <span style="color:var(--al-danger)">Date is required</span>
        }
        <!-- <span style="color:var(--al-danger)" *ngIf="!record.datefutureValid">Future Date is not allowed</span> -->
      </td>
      <td>
        <textarea class="form-control p-2"  [(ngModel)]="record.description" (ngModelChange)="checkDuplicateTR()" id="description"
        [disabled]="acceptDdata.descriptionTypeCode=='Auto' || record.disableInp" appSpellCheck></textarea>
        @if (!record.descValid) {
          <span style="color:var(--al-danger)">Description is required</span>
        }
      </td>
      <td>
        <textarea class="form-control p-2" [(ngModel)]="record.tkComment" id="tkComment"
        [disabled]="record.disableInp" appSpellCheck></textarea>
      </td>
      <td>
        <p-calendar appendTo="body" [showTime]="true" hourFormat="24" [timeOnly]="true"
          [(ngModel)]="record.enteredTime" [defaultDate]="defaultTime" [disabled]="record.disableInp">
        </p-calendar>
        @if (!record.timeValid) {
          <span style="color:var(--al-danger)">Time is required</span>
        }
      </td>
      <td>
        @if (record.quantityType?.toUpperCase() == 'NUMBER' ) {
          <input class="form-control p-2" type="number" [(ngModel)]="record.quantity" id="quantity"
            [disabled]=" record.disableInp ||record.disableQuantity">
        }
        @if (record.quantityType?.toUpperCase() == 'STATE' ) {
          <p-multiSelect [maxSelectedLabels]="10000" appendTo="body" [disabled]=" record.disableInp||record.disableQuantity " defaultLabel="Select State"
            [(ngModel)]="record.quantityStateList" [options]="stateCodeMapList" optionLabel="label"
          optionValue="label"></p-multiSelect>
        }
      </td>
      <td>
        {{record['timeRecStatus']}}
      </td>
      <td>
        <span appActionTooltip [pTooltip]="record.disableDel ? getDeleteTRDisabledReason(record) : 'Delete time record'" [actionDisabled]="record.disableDel">
          <button [disabled]="record.disableDel" class="btn btn-warning btn-sm"
            (click)="deleteTR(rowIndex)" role="button"><i class="mdi mdi-trash-can"></i></button>
        </span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="4" style="padding: 1rem !important;">
          No records found
        </td>
      </tr>
    </ng-template>
  </p-table>

  @if (hasDuplicateTR) {
    <div class="row m-2">
      <div class="col-12">
        <span style="color:var(--al-danger)">Duplicate time record — a record with the same date and description already exists.</span>
      </div>
    </div>
  }

  @if (enableDeleteTask) {
    <div class="row m-2">
      <div class="col-sm" style="margin:10px; ">
        <span appActionTooltip [pTooltip]="deleteReason === '' ? getDeleteReasonDisabledReason() : 'Delete task'" [actionDisabled]="deleteReason === ''" style="float: right;">
          <button type="button" class="btn btn-danger"  [disabled]="deleteReason===''" (click)="deleteTask(taskForm.getRawValue())" style="float: right;">Delete
            @if (loadingData) {
              <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
            }
          </button>
        </span>
        <select id="deleteReason" class="form-select" [(ngModel)]="deleteReason" required style="width: 25%;float: right;margin-right: 5px;">
          <option selected [value]="">Select Delete Reason</option>
          @for (reason of deleteReasonList; track reason) {
            <option [value]="reason.value">
              {{reason.label}}
            </option>
          }
        </select>
        <label class="form-check-label" for="deleteTr" style="float: right;margin-top: 5px; margin-right:40px">
          Delete Time Records
        </label>
        <input class="form-check-input" id="deleteTr" type="checkbox" [(ngModel)]="rejectTimeRecords" style="float: right;margin-top: 10px;margin-right:5px ;"
          >
      </div>
    </div>
  }

  @if (!enableDeleteTask) {
    <div class="row">
      <div class="col-xl-12">
        <div class="button-items" style="float: right;padding:10px;">
          <span appActionTooltip [pTooltip]="timeRecords.length == 0 ? getSaveTRDisabledReason() : 'Save time records'" [actionDisabled]="timeRecords.length == 0">
            <button class="btn btn-primary" [disabled]="timeRecords.length==0 || hasDuplicateTR" (click)="saveTR()">Save</button>
          </span>
          <!-- <button class="btn btn-danger" *ngIf="enableDeleteTask" [disabled]="deleteReason===''" (click)="saveTR()">Delete</button> -->
          <!-- <button class="btn btn-success" (click)="submitForm()">Submit</button> -->
          <!-- <button class="btn btn-danger" (click)="resetForm()">Reset</button> -->
        </div>
      </div>
    </div>
  }
</ng-template>
</p-dialog>


<p-dialog [(visible)]="forApprovalDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
  [style]="{width: '80%'}" [header]="title" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-notification [errorMsg]="errorMsg"></app-notification>
    @if (faloading) {
      <div class="loader">
        <div class="spinner"></div>
      </div>
    }
    <form [formGroup]="taskForm">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-4 mb-1">
              <label for="taskName" class="form-label mb-0">Task Name
                @if (getFieldInfo('taskName'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" formControlName="taskName" readonly
                id="taskName">
            </div>
            <div class="col-xl-4 mb-1">
              <label for="projectName" class="form-label mb-0">Project Name
                @if (getFieldInfo('projectName'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" formControlName="projectName" readonly
                id="projectName">
            </div>
            <div class="col-xl-4 mb-1">
              <label for="matterName" class="form-label mb-0">Matter Name
                @if (getFieldInfo('matterName'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" formControlName="matterName" readonly
                id="matterName">
            </div>
            <div class="col-xl-4 mb-1">
              <label for="orgName" class="form-label mb-0">Organization Name
                @if (getFieldInfo('orgName'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" formControlName="orgName" readonly id="orgName">
            </div>
            <div class="col-xl-4 mb-1">
              <label for="timeEstimate" class="form-label mb-0">Estimated Time(HH:MM)
                @if (getFieldInfo('timeEstimate'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24" [timeOnly]="true"
                formControlName="timeEstimate" [defaultDate]="defaultTime">
              </p-calendar>
            </div>
            @if (lpcdashboard || !onlytk) {
              <div class="col-xl-4 mb-1">
                <label for="maxTime" class="form-label mb-0">Max Time(HH:MM)
                  @if (getFieldInfo('maxTime'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24" [timeOnly]="true"
                  formControlName="maxTime" [defaultDate]="defaultTime">
                </p-calendar>
              </div>
            }
            <div class="col-xl-4 mb-1">
              <label for="isRequireEstimate" class="form-label mb-0">Required Estimate
                @if (getFieldInfo('isRequireEstimate'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>

              <input class="form-control p-2" formControlName="isRequireEstimate" readonly
                id="isRequireEstimate">
            </div>
            <div class="col-xl-4 mb-1">
              <label for="taskDueDate" class="form-label mb-0">Due Date
                @if (getFieldInfo('taskDueDate'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="datetime" formControlName="taskDueDate" readonly
                id="taskDueDate">
            </div>
            <div class="col-xl-4 mb-1">
              <label for="dueDaySlot" class="form-label mb-0">Due Date Slot
                @if (getFieldInfo('dueDaySlot'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" formControlName="dueDaySlot"  readonly 
                id="dueDaySlot">
            </div>
            <div class="col-xl-4 mb-1">
              <label for="timeRecordsLoggedTime" class="form-label mb-0">Logged Time(HH:MM)
                @if (getFieldInfo('timeRecordsLoggedTime'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24"  readonly 
                [timeOnly]="true" formControlName="timeRecordsLoggedTime" [defaultDate]="defaultTime">
              </p-calendar>
            </div>
            <div class="col-xl-2 mb-1">
              <label for="stateDesc" class="form-label mb-0">State
                @if (getFieldInfo('stateDesc'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control p-2" type="text" formControlName="stateDesc"  readonly 
                id="stateDesc">
            </div>
            <div class="col-xl-2 mb-1">
              <label for="tkRating" class="form-label mb-0">TK Rating
                @if (getFieldInfo('tkRating'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <select class="form-select" id="tkRating" formControlName="tkRating" required>
                <option value="" selected>Select</option>
                <option value="1" >1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>

            </div>
            <div class="col-xl-2">
              <div style=" height: 50%;"></div>
              <div class="form-check">
                <input class="form-check-input" id="isIncludeToday" type="checkbox" formControlName="includeToday"  readonly >
                <label class="form-check-label" for="isIncludeToday">
                  Include Today
                  @if (getFieldInfo('includeToday'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
              </div>
            </div>
            <div class="col-xl-2">
              <div style=" height: 50%;"></div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="isBillable">
                <label class="form-check-label" for="isBillable">
                  Billable
                  @if (getFieldInfo('isBillable'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
              </div>
            </div>

          </div>
        </div>
      </div>

    </form>
    <p-table [(value)]="timeRecords" dataKey="id" [scrollable]="true" scrollDirection="both"
      scrollHeight="150px" styleClass="p-datatable-daywiseData" responsiveLayout="scroll" rows="5"
      [rowHover]="true" class="insidetable" [loading]="loadingTRData" responsiveLayout="scroll">

      <ng-template pTemplate="header">
        <tr>
          <th>Date</th>
          <th>Time Spent(HH:MM)</th>
          <th>Description</th>
          <th>Status</th>

        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-day let-columns="columns">
        <tr>
          <td style="padding:0px 0 px">
            <p-calendar appendTo="body" readonly [(ngModel)]="day['date']">
            </p-calendar>
          </td>
          <td style="padding:0px 0 px">
            <p-calendar appendTo="body" [showTime]="true" readonly hourFormat="24" [timeOnly]="true"
            [(ngModel)]="day['enteredTime']" [defaultDate]="defaultTime"></p-calendar>
          </td>

          <td style="padding:0rem 0rem">
            {{day['description']}}
          </td>
          <td style="padding:0rem 0rem">
            {{day['timeRecStatus']}}
          </td>

        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="4" style="padding: 1rem !important;">
            No records found
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="row mt-3">
      <div class="col-xl-2" >
        <label class="toggle-label" style="margin-right: 3%;margin-top:2%">
          <input type="radio" name="status" value="approve" [(ngModel)]="radioStatus" [disabled]="FAdisableFlag"
            (change)="toggleStatus()">
          Approve
        </label>

        <label class="toggle-label" style="margin-top:2%">
          <input type="radio" name="status" value="reject" [disabled]="FAdisableFlag" [(ngModel)]="radioStatus"
            (change)="toggleStatus()">
          Reject
        </label>
      </div>
      <div class="reason-container col-xl-6">
        @if (radioStatus === 'reject') {
          <span>
            <input type="textarea"  [(ngModel)]="rejectedReason" [disabled]="FAdisableFlag" placeholder="Enter Rejection Reason" class="form-control p-2"  required appSpellCheck>
          </span>
        }
      </div>
      <div class="col-xl-2" ></div>
      <div class="col-xl-2">
        <div class="button-items " style="padding:10px;">
          <span appActionTooltip [pTooltip]="((radioStatus === 'approve') || FAdisableFlag || !taskForm.getRawValue().tkRating) ? getFARejectDisabledReason() : 'Reject task'" [actionDisabled]="(radioStatus === 'approve') || FAdisableFlag || !taskForm.getRawValue().tkRating" style="float: right;">
            <button type="button" class="btn btn-danger" style="float: right;"
            [disabled]="(radioStatus === 'approve' )|| FAdisableFlag  || !taskForm.getRawValue().tkRating" (click)="rejectTask(taskForm)">Reject</button>
          </span>
          <span appActionTooltip [pTooltip]="((radioStatus === 'reject' && !rejectedReason) || FAdisableFlag || !taskForm.getRawValue().tkRating) ? getFAApproveDisabledReason() : 'Approve task'" [actionDisabled]="(radioStatus === 'reject' && !rejectedReason) || FAdisableFlag || !taskForm.getRawValue().tkRating" style="float: right;">
            <button type="submit" class="btn btn-success" style="float: right;"
              [disabled]="(radioStatus === 'reject' && !rejectedReason )|| FAdisableFlag || !taskForm.getRawValue().tkRating"
            (click)="approveTask(taskForm)">Approve</button>
          </span>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false" [draggable]="false" [(visible)]="deleteConfirmationDialog" (onHide)="closeDialog()"
  [style]="{'width': '40%', 'max-height':'85%'}" [header]="title" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-notification [errorMsg]="errorMsg"></app-notification>
    <form [formGroup]="taskForm">
      <div class="row">
        <div class="col-xl-4">
          <div class="mb-1">
            <label for="taskName" class="form-label mb-1">Task Name
              @if (getFieldInfo('taskName'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <input class="form-control p-2" type="text" readonly formControlName="taskName"
              id="taskName">
          </div>
        </div>
        <div class="col-xl-4">
          <div class="mb-1">
            <label for="orgName" class="form-label mb-1">Organization Name
              @if (getFieldInfo('orgName'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <input class="form-control p-2" type="text" readonly formControlName="orgName"
              id="orgName">
          </div>
        </div>
        <div class="col-xl-4">
          <div class="mb-1">
            <label for="matterName" class="form-label mb-1">Matter Name
              @if (getFieldInfo('matterName'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <input class="form-control p-2" type="text" readonly formControlName="matterName"
              id="matterName">
          </div>
        </div>
        <div class="question" >
          <p>{{deleteConfirmationDialogText}}</p>
        </div>
        <div class="question" >
          <span appActionTooltip [pTooltip]="loadingData ? getDeleteConfirmDisabledReason() : 'Confirm deletion'" [actionDisabled]="loadingData">
            <button type="submit" class="btn btn-success" (click)="deleteTask(taskForm.getRawValue())" [disabled]="loadingData" style="margin-left: 2%;margin-right: 3%;">Yes
              @if (loadingData) {
                <i class="fa fa-solid fa-sync fa-spin"></i>
              }
            </button>
          </span>
          <button type="button" class="btn btn-danger" pTooltip="Cancel" appActionTooltip (click)="closeDialog()">No</button>
        </div>
      </div>
    </form>
  </ng-template>
</p-dialog>

<!-- Comments Dialog -->
<p-dialog [(visible)]="commentsDialog" [resizable]="false" [draggable]="false" (onHide)="closeCommentsDialog()"
  [header]="selectedTaskForComments?.projectName + ' - ' + selectedTaskForComments?.taskName + ' (Task ID: ' + (selectedTaskForComments?.id) + ')'"
  [modal]="true" [style]="{width: '800px', 'min-height': '500px', 'max-height': '80vh'}">
  @if (selectedTaskForComments) {
    <app-comments
      [targetType]="'Task'"
      [targetId]="selectedTaskForComments.id"
        [taskInfo]="{
            projectName: selectedTaskForComments.projectName,
            taskName: selectedTaskForComments.taskName,
            taskId: selectedTaskForComments.id
        }">
    </app-comments>
  }
</p-dialog>

<!-- Entity Dialog -->
<app-entity-form
  [entity]="entityToEdit"
  [visible]="entityDialog"
  [readOnly]="false"
  [title]="'Add New Entity'"
  (visibleChange)="onEntityDialogVisibleChange($event)"
  (entitySaved)="onEntitySaved($event)">
</app-entity-form>

<!-- Update/Show Entity Information Dialog (for Add Time Record) -->
<app-entity-form
  [entity]="entityToEdit"
  [visible]="updateEntityDialog"
  [readOnly]="false"
  [title]="basicEntityEditMode ? 'Update Entity Information' : (isEntityInfoComplete() ? 'Show Entity Information' : 'Update Entity Information')"
  [isTaskContext]="true"
  [skipIsTKUpdatedEntity]="skipIsTKUpdatedEntity"
  [basicEditMode]="basicEntityEditMode"
  (visibleChange)="onUpdateEntityDialogVisibleChange($event)"
  (entitySaved)="onEntityUpdated($event)">
</app-entity-form>

<app-confirmation-alert [showAlert]="showConfirmAlert" [message]="confirmMessage" (response)="onConfirmResponse($event)"></app-confirmation-alert>

<p-dialog [(visible)]="reminderDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
  [style]="{width: '90%'}" [header]="'Reminders' + ' (Task Name: ' + (selectedTask?.taskName) + ')'" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-reminder [taskId]="selectedTask?.id"></app-reminder>
  </ng-template>
</p-dialog>


<p-dialog [(visible)]="reminderNotificationDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
  [style]="{width: '70%'}" [header]="'Reminder Notifications' + ' (Task Name: ' + (selectedTask?.taskName) + ')'" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-reminder-notifications [notifications]="selectedTask?.unreadReminderNotifications"></app-reminder-notifications>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="gridSettingsDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
  [style]="{width: '70%'}" [header]="'Grid Settings'" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-grid-settings-mapper  [category]="'Project Task'" [availableColumns]="availableColumns" [customCols]="customCols" [defaultColumns]="getDefaultGridColumns()" (onSaved)="saveCustomSettings();closeSettingsDialog();"></app-grid-settings-mapper>
  </ng-template>
</p-dialog>


<p-dialog [(visible)]="auditDialog" (onHide)="closeAuditDialog()" [style]="{'width': '60%', 'max-height':'75%'}"
  [resizable]="false" [draggable]="false" [header]="auditTitle" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-audit-table
      [tableName]="tableName"
      [recordId]="auditRecordId"
    [fieldName]="auditField"></app-audit-table>
  </ng-template>
</p-dialog>
